const medications = {
    "data": [
      "ABACAVIR AND LAMIVUDINE",
      "ABACAVIR SULFATE",
      "ABACAVIR SULFATE AND LAMIVUDINE",
      "ABACAVIR SULFATE, LAMIVUDINE AND ZIDOVUDINE",
      "ABACAVIR SULFATE",
      " LAMIVUDINE",
      "ABACAVIR",
      " DOLUTEGRAVIR",
      " LAMIVUDINE",
      "ABACAVIR",
      " LAMIVUDINE",
      "ABELCET",
      "ABILIFY",
      "ABILIFY ASIMTUFII",
      "ABILIFY MAINTENA KIT",
      "ABILIFY MYCITE KIT",
      "ABIRATERONE ACETATE",
      "ABLYSINOL",
      "ABRAXANE",
      "ABREVA",
      "ABRILADA",
      "ABSORICA",
      "ABSORICA LD",
      "ACALABRUTINIB",
      "ACAMPROSATE CALCIUM",
      "ACANYA",
      "ACARBOSE",
      "ACCOLATE",
      "ACEBUTOLOL HYDROCHLORIDE",
      "ACEPHEN",
      "ACETADOTE",
      "ACETAMINOPHEN",
      "ACETAMINOPHEN AND CODEINE PHOSPHATE",
      "ACETAMINOPHEN AND IBUPROFEN",
      "ACETAMINOPHEN, ASPIRIN AND CAFFEINE",
      "ACETAMINOPHEN, CAFFEINE AND DIHYDROCODEINE BITARTRATE",
      "ACETAMINOPHEN",
      " OXYCODONE HYDROCHLORIDE",
      "ACETAZOLAMIDE",
      "ACETAZOLAMIDE SODIUM",
      "ACETIC ACID",
      "ACETIC ACID 0.25% IN PLASTIC CONTAINER",
      "ACETYLCYSTEINE",
      "ACHROMYCIN V",
      "ACIPHEX",
      "ACITRETIN",
      "ACTEMRA",
      "ACTHAR GEL",
      "ACTHREL",
      "ACTICLATE",
      "ACTIGALL",
      "ACTIMMUNE",
      "ACTIQ",
      "ACTIVASE",
      "ACTIVELLA",
      "ACTONEL",
      "ACTOPLUS MET",
      "ACTOS",
      "ACULAR",
      "ACULAR LS",
      "ACUVAIL",
      "ACYCLOVIR",
      "ACYCLOVIR SODIUM",
      "ACZONE",
      "ADAKVEO",
      "ADAPALENE",
      "ADAPALENE AND BENZOYL PEROXIDE",
      "ADASUVE",
      "ADBRY",
      "ADCETRIS",
      "ADDERALL XR 10",
      "ADDERALL XR 15",
      "ADDERALL XR 20",
      "ADDERALL XR 25",
      "ADDERALL XR 30",
      "ADDERALL XR 5",
      "ADDYI",
      "ADEFOVIR DIPIVOXIL",
      "ADEMPAS",
      "ADENOSINE",
      "ADIPEX-P",
      "ADLARITY",
      "ADLYXIN",
      "ADMELOG",
      "ADMELOG SOLOSTAR",
      "ADRENACLICK",
      "ADRENALIN",
      "ADREVIEW",
      "ADUHELM",
      "ADVAIR DISKUS 100/50",
      "ADVAIR DISKUS 250/50",
      "ADVAIR DISKUS 500/50",
      "ADVIL",
      "ADVIL ALLERGY AND CONGESTION RELIEF",
      "ADVIL ALLERGY SINUS",
      "ADVIL COLD AND SINUS",
      "ADVIL CONGESTION RELIEF",
      "ADVIL DUAL ACTION WITH ACETAMINOPHEN",
      "ADVIL LIQUI-GELS",
      "ADVIL MIGRAINE LIQUI-GELS",
      "ADVIL MULTI-SYMPTOM COLD & FLU",
      "ADVIL PM",
      "ADZENYS XR-ODT",
      "AEMCOLO",
      "AFATINIB",
      "AFINITOR DISPERZ",
      "AFIRMELLE",
      "AFREZZA",
      "AGGRASTAT",
      "AGRYLIN",
      "AIMOVIG",
      "AIRDUO DIGIHALER",
      "AIRDUO RESPICLICK",
      "AIRSUPRA",
      "AJOVY",
      "AK-FLUOR 10%",
      "AK-FLUOR 25%",
      "AKEEGA",
      "AKLIEF",
      "AKOVAZ",
      "AKPENTOLATE",
      "AKTEN",
      "AKYNZEO",
      "ALA-CORT",
      "ALA-SCALP",
      "ALAVERT",
      "ALAWAY",
      "ALBENDAZOLE",
      "ALBUTEROL SULFATE",
      "ALBUTEROL SULFATE AND IPRATROPIUM BROMIDE",
      "ALBUTEROL SULFATE",
      " IPRATROPIUM BROMIDE",
      "ALCAFTADINE",
      "ALCAINE",
      "ALCLOMETASONE DIPROPIONATE",
      "ALDACTAZIDE",
      "ALDACTONE",
      "ALDURAZYME",
      "ALECENSA",
      "ALENDRONATE SODIUM",
      "ALEVE",
      "ALFENTA",
      "ALFENTANIL",
      "ALFERON N INJECTION",
      "ALFUZOSIN HYDROCHLORIDE",
      "ALIMTA",
      "ALINIA",
      "ALIQOPA",
      "ALISKIREN HEMIFUMARATE",
      "ALKINDI SPRINKLE",
      "ALLEGRA ALLERGY",
      "ALLEGRA HIVES",
      "ALLEGRA-D 12 HOUR ALLERGY AND CONGESTION",
      "ALLEGRA-D 24 HOUR ALLERGY AND CONGESTION",
      "ALLI",
      "ALLOPURINOL",
      "ALLOPURINOL SODIUM",
      "ALLZITAL",
      "ALMOTRIPTAN MALATE",
      "ALOGLIPTIN",
      "ALOGLIPTIN AND METFORMIN HYDROCHLORIDE",
      "ALOGLIPTIN",
      " METFORMIN HYDROCHLORIDE",
      "ALOMIDE",
      "ALOPRIM",
      "ALOSETRON HYDROCHLORIDE",
      "ALPHAGAN P",
      "ALPRAZOLAM",
      "ALPROSTADIL",
      "ALREX",
      "ALTABAX",
      "ALTACE",
      "ALTAFLUOR BENOX",
      "ALTAVERA",
      "ALTOPREV",
      "ALTRENO",
      "ALUNBRIG",
      "ALVAIZ",
      "ALVESCO",
      "ALVIMOPAN",
      "ALYACEN 1/35",
      "ALYACEN 7/7/7",
      "ALYACEN 777",
      "ALYMSYS",
      "ALYQ",
      "AMABELZ",
      "AMANTADINE",
      "AMANTADINE HYDROCHLORIDE",
      "AMARYL",
      "AMBIEN",
      "AMBIEN CR",
      "AMBISOME",
      "AMBRISENTAN",
      "AMCINONIDE",
      "AMELUZ",
      "AMERGE",
      "AMICAR",
      "AMIDATE",
      "AMIKACIN SULFATE",
      "AMILORIDE HYDROCHLORIDE",
      "AMILORIDE HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
      "AMINO ACIDS",
      "AMINOACETIC ACID 1.5% IN PLASTIC CONTAINER",
      "AMINOCAPROIC ACID",
      "AMINOCAPROIC ACID IN PLASTIC CONTAINER",
      "AMINOPHYLLINE",
      "AMINOSYN II 10% IN PLASTIC CONTAINER",
      "AMINOSYN II 15% IN PLASTIC CONTAINER",
      "AMINOSYN-PF 10%",
      "AMINOSYN-PF 7%",
      "AMIODARONE HYDROCHLORIDE",
      "AMITIZA",
      "AMITRIPTYLINE HYDROCHLORIDE",
      "AMJEVITA",
      "AMLODIPINE AND OLMESARTAN MEDOXOMIL",
      "AMLODIPINE BESYLATE",
      "AMLODIPINE BESYLATE AND ATORVASTATIN CALCIUM",
      "AMLODIPINE BESYLATE AND BENAZEPRIL HYDROCHLORIDE",
      "AMLODIPINE BESYLATE AND VALSARTAN",
      "AMLODIPINE BESYLATE, VALSARTAN AND HYDROCHLOROTHIAZIDE",
      "AMLODIPINE BESYLATE",
      " BENAZEPRIL HYDROCHLORIDE",
      "AMLODIPINE MALEATE",
      " BENAZEPRIL HYDROCHLORIDE",
      "AMMONIA N 13",
      "AMMONIUM LACTATE",
      "AMNESTEEM",
      "AMONDYS 45",
      "AMOXAPINE",
      "AMOXICILLIN",
      "AMOXICILLIN AND CLAVULANATE POTASSIUM",
      "AMOXICILLIN PEDIATRIC",
      "AMOXIL",
      "AMPHADASE",
      "AMPHETAMINE",
      "AMPHETAMINE SULFATE",
      "AMPHOTERICIN B",
      "AMPICILLIN AND SULBACTAM",
      "AMPICILLIN SODIUM",
      "AMPICILLIN TRIHYDRATE",
      "AMPYRA",
      "AMRINONE LACTATE",
      "AMRIX",
      "AMVUTTRA",
      "AMYVID",
      "AMZEEQ",
      "AN-SULFUR COLLOID",
      "ANAFRANIL",
      "ANAGRELIDE HYDROCHLORIDE",
      "ANAPROX DS",
      "ANASTROZOLE",
      "ANCEF IN PLASTIC CONTAINER",
      "ANCOBON",
      "ANDROGEL",
      "ANDROID 25",
      "ANECTINE",
      "ANEXSIA 5/325",
      "ANEXSIA 7.5/325",
      "ANGELIQ",
      "ANGIOMAX",
      "ANNOVERA",
      "ANORO ELLIPTA",
      "ANTARA (MICRONIZED)",
      "ANTHELIOS 20",
      "ANTHELIOS 40",
      "ANTHELIOS SX",
      "ANTHIM",
      "ANTIVERT",
      "ANUSOL HC",
      "ANZEMET",
      "APIDRA",
      "APIDRA SOLOSTAR",
      "APIXABAN",
      "APLENZIN",
      "APOKYN",
      "APOMORPHINE HYDROCHLORIDE",
      "APONVIE",
      "APRACLONIDINE HYDROCHLORIDE",
      "APREMILAST",
      "APREPITANT",
      "APRETUDE",
      "APRISO",
      "APTENSIO XR",
      "APTIOM",
      "APTIVUS",
      "AQUASOL A",
      "ARAKODA",
      "ARANELLE",
      "ARANESP",
      "ARAVA",
      "ARAZLO",
      "ARCALYST",
      "AREDIA",
      "ARFORMOTEROL TARTRATE",
      "ARGATROBAN",
      "ARGATROBAN IN SODIUM CHLORIDE",
      "ARICEPT",
      "ARIDOL",
      "ARIDOL KIT",
      "ARIKAYCE KIT",
      "ARIMIDEX",
      "ARIPIPRAZOLE",
      "ARISTADA",
      "ARISTADA INITIO KIT",
      "ARIXTRA",
      "ARMODAFINIL",
      "ARMONAIR DIGIHALER",
      "ARNUITY ELLIPTA",
      "AROMASIN",
      "ARRANON",
      "ARSENIC TRIOXIDE",
      "ARTESUNATE",
      "ARTHROTEC",
      "ARZERRA",
      "ASCLERA",
      "ASCOR",
      "ASENAPINE MALEATE",
      "ASHLYNA",
      "ASMANEX HFA",
      "ASMANEX TWISTHALER",
      "ASPARLAS",
      "ASPIRIN AND DIPYRIDAMOLE",
      "ASPIRIN",
      " OMEPRAZOLE",
      "ASPRUZYO SPRINKLE",
      "ASTAGRAF XL",
      "ASTEPRO",
      "ASTEPRO ALLERGY",
      "ATACAND",
      "ATACAND HCT",
      "ATAZANAVIR SULFATE",
      "ATAZANAVIR SULFATE AND RITONAVIR",
      "ATAZANAVIR SULFATE",
      " RITONAVIR",
      "ATAZANAVIR SULFATE",
      "RITONAVIR",
      "LAMIVUDINE",
      "ZIDOVUDINE",
      "ATELVIA",
      "ATENOLOL",
      "ATENOLOL AND CHLORTHALIDONE",
      "ATHENTIA NEXT",
      "ATIVAN",
      "ATOMOXETINE HYDROCHLORIDE",
      "ATORVALIQ",
      "ATORVASTATIN CALCIUM",
      "ATOVAQUONE",
      "ATOVAQUONE AND PROGUANIL HYDROCHLORIDE",
      "ATRACURIUM BESYLATE",
      "ATRACURIUM BESYLATE PRESERVATIVE FREE",
      "ATRALIN",
      "ATRIPLA",
      "ATROPINE SULFATE",
      "ATROVENT HFA",
      "AUGMENTIN '125'",
      "AUGMENTIN '250'",
      "AUGMENTIN '875'",
      "AUGMENTIN ES-600",
      "AUROVELA 1.5/30",
      "AUROVELA 1/20",
      "AUROVELA 24 FE",
      "AUROVELA FE 1.5/30",
      "AUROVELA FE 1/20",
      "AURYXIA",
      "AUSTEDO",
      "AUSTEDO XR",
      "AUVELITY",
      "AUVI-Q",
      "AVAGARD",
      "AVAGE",
      "AVALIDE",
      "AVAPRO",
      "AVASTIN",
      "AVEED",
      "AVELOX",
      "AVIANE-28",
      "AVITA",
      "AVODART",
      "AVONEX",
      "AVSOLA",
      "AVYCAZ",
      "AXID AR",
      "AXITINIB",
      "AXUMIN",
      "AYUNA",
      "AYVAKIT",
      "AZACITIDINE",
      "AZACTAM",
      "AZASAN",
      "AZASITE",
      "AZATHIOPRINE",
      "AZATHIOPRINE SODIUM",
      "AZEDRA",
      "AZELAIC ACID",
      "AZELASTINE HYDROCHLORIDE",
      "AZELASTINE HYDROCHLORIDE AND FLUTICASONE PROPIONATE",
      "AZELEX",
      "AZILECT",
      "AZITHROMYCIN",
      "AZOPT",
      "AZOR",
      "AZSTARYS",
      "AZTREONAM",
      "AZULFIDINE",
      "AZULFIDINE EN-TABS",
      "BACITRACIN",
      "BACITRACIN ZINC AND POLYMYXIN B SULFATE",
      "BACITRACIN-NEOMYCIN-POLYMYXIN W/ HYDROCORTISONE ACETATE",
      "BACLOFEN",
      "BACTERIOSTATIC SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "BACTERIOSTATIC WATER FOR INJECTION IN PLASTIC CONTAINER",
      "BACTOCILL IN PLASTIC CONTAINER",
      "BACTRIM",
      "BACTRIM DS",
      "BAFIERTAM",
      "BALANCED SALT",
      "BALCOLTRA",
      "BALSALAZIDE DISODIUM",
      "BALVERSA",
      "BALZIVA-28",
      "BANZEL",
      "BAQSIMI",
      "BARACLUDE",
      "BARHEMSYS",
      "BASAGLAR",
      "BAVENCIO",
      "BAXDELA",
      "BECONASE AQ",
      "BEKYREE",
      "BELBUCA",
      "BELEODAQ",
      "BELRAPZO",
      "BELSOMRA",
      "BENAZEPRIL HYDROCHLORIDE",
      "BENAZEPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
      "BENDAMUSTINE HYDROCHLORIDE",
      "BENDEKA",
      "BENICAR",
      "BENICAR HCT",
      "BENLYSTA",
      "BENTYL",
      "BENTYL PRESERVATIVE FREE",
      "BENZAMYCIN",
      "BENZNIDAZOLE",
      "BENZONATATE",
      "BENZOYL PEROXIDE AND CLINDAMYCIN PHOSPHATE",
      "BENZOYL PEROXIDE",
      " CLINDAMYCIN PHOSPHATE",
      "BENZPHETAMINE HYDROCHLORIDE",
      "BENZTROPINE MESYLATE",
      "BEOVU",
      "BEPOTASTINE BESILATE",
      "BEPREVE",
      "BESIVANCE",
      "BESPONSA",
      "BESREMI",
      "BETA-VAL",
      "BETADINE",
      "BETAINE",
      "BETAMETHASONE ACETATE AND BETAMETHASONE SODIUM PHOSPHATE",
      "BETAMETHASONE DIPROPIONATE",
      "BETAMETHASONE VALERATE",
      "BETAPACE",
      "BETAPACE AF",
      "BETASERON",
      "BETAXOLOL HYDROCHLORIDE",
      "BETHANECHOL CHLORIDE",
      "BETHKIS",
      "BETIMOL",
      "BETOPTIC",
      "BETOPTIC S",
      "BEVESPI AEROSPHERE",
      "BEXAROTENE",
      "BEYAZ",
      "BEYFORTUS",
      "BIAXIN XL",
      "BICALUTAMIDE",
      "BICILLIN C-R",
      "BICILLIN C-R 900/300",
      "BICILLIN L-A",
      "BICNU",
      "BIDIL",
      "BIJUVA",
      "BIKTARVY",
      "BILTRICIDE",
      "BIMATOPROST",
      "BINOSTO",
      "BIORPHEN",
      "BIOSCRUB",
      "BISMUTH SUBCITRATE POTASSIUM, METRONIDAZOLE AND TETRACYCLINE HYDROCHLORIDE",
      "BISMUTH SUBSALICYLATE, METRONIDAZOLE AND TETRACYCLINE HYDROCHLORIDE",
      "BISOPROLOL FUMARATE",
      "BISOPROLOL FUMARATE AND HYDROCHLOROTHIAZIDE",
      "BIVALIRUDIN",
      "BLENREP",
      "BLEOMYCIN SULFATE",
      "BLEPH-10",
      "BLINCYTO",
      "BLISOVI 24 FE",
      "BLISOVI FE 1.5/30",
      "BLISOVI FE 1/20",
      "BLOXIVERZ",
      "BLUDIGO",
      "BONJESTA",
      "BONSITY",
      "BONTRIL PDM",
      "BORTEZOMIB",
      "BOSENTAN",
      "BOSULIF",
      "BOTOX",
      "BOTOX COSMETIC",
      "BRAFTOVI",
      "BRAVELLE",
      "BRENZAVVY",
      "BREO ELLIPTA",
      "BRETHINE",
      "BREVIBLOC",
      "BREVIBLOC DOUBLE STRENGTH IN PLASTIC CONTAINER",
      "BREVIBLOC IN PLASTIC CONTAINER",
      "BREVITAL SODIUM",
      "BREXAFEMME",
      "BREXPIPRAZOLE",
      "BREYNA",
      "BREZTRI AEROSPHERE",
      "BRIDION",
      "BRIELLYN",
      "BRILINTA",
      "BRIMONIDINE TARTRATE",
      "BRIMONIDINE TARTRATE AND TIMOLOL MALEATE",
      "BRIMONIDINE TARTRATE",
      " TIMOLOL MALEATE",
      "BRINEURA",
      "BRINZOLAMIDE",
      "BRISDELLE",
      "BRIUMVI",
      "BRIVARACETAM",
      "BRIVIACT",
      "BRIXADI",
      "BROMFED-DM",
      "BROMFENAC SODIUM",
      "BROMOCRIPTINE MESYLATE",
      "BROMPHENIRAMINE MALEATE",
      "BROMPHENIRAMINE MALEATE, PSEUDOEPHEDRINE HYDROCHLORIDE AND DEXTROMETHORPHAN HYDROBROMIDE",
      "BROMSITE",
      "BRONCHITOL",
      "BROVANA",
      "BRUKINSA",
      "BRYHALI",
      "BSS",
      "BSS PLUS",
      "BUDESONIDE",
      "BUMETANIDE",
      "BUMEX",
      "BUPHENYL",
      "BUPIVACAINE HYDROCHLORIDE",
      "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE",
      "BUPIVACAINE HYDROCHLORIDE PRESERVATIVE FREE",
      "BUPRENORPHINE",
      "BUPRENORPHINE HYDROCHLORIDE",
      "BUPRENORPHINE HYDROCHLORIDE AND NALOXONE HYDROCHLORIDE",
      "BUPRENORPHINE HYDROCHLORIDE",
      " NALOXONE HYDROCHLORIDE",
      "BUPROPION HYDROBROMIDE",
      "BUPROPION HYDROCHLORIDE",
      "BUSPIRONE HYDROCHLORIDE",
      "BUSULFAN",
      "BUSULFEX",
      "BUTALBITAL AND ACETAMINOPHEN",
      "BUTALBITAL, ACETAMINOPHEN AND CAFFEINE",
      "BUTALBITAL, ACETAMINOPHEN, CAFFEINE AND CODEINE PHOSPHATE",
      "BUTALBITAL, ASPIRIN AND CAFFEINE",
      "BUTALBITAL, ASPIRIN, CAFFEINE, AND CODEINE PHOSPHATE",
      "BUTALBITAL",
      " ACETAMINOPHEN",
      " CAFFEINE",
      " CODEINE",
      "BUTAPAP",
      "BUTENAFINE HYDROCHLORIDE",
      "BUTORPHANOL TARTRATE",
      "BUTORPHANOL TARTRATE PRESERVATIVE FREE",
      "BUTRANS",
      "BYDUREON BCISE",
      "BYETTA",
      "BYFAVO",
      "BYLVAY",
      "BYOOVIZ",
      "BYSTOLIC",
      "CABAZITAXEL",
      "CABAZITAXEL INJECTION",
      "CABENUVA KIT",
      "CABERGOLINE",
      "CABLIVI",
      "CABOMETYX",
      "CABOZANTINIB",
      "CADUET",
      "CAFCIT",
      "CAFFEINE CITRATE",
      "CALCIPOTRIENE",
      "CALCIPOTRIENE AND BETAMETHASONE DIPROPIONATE",
      "CALCIPOTRIENE AND BETHAMETHASONE DIPROPIONATE",
      "CALCITONIN-SALMON",
      "CALCITRIOL",
      "CALCIUM ACETATE",
      "CALCIUM CHLORIDE 10%",
      "CALCIUM CHLORIDE 10% IN PLASTIC CONTAINER",
      "CALCIUM GLUCONATE",
      "CALCIUM GLUCONATE IN SODIUM CHLORIDE",
      "CALDOLOR",
      "CALQUENCE",
      "CAMBIA",
      "CAMCEVI KIT",
      "CAMILA",
      "CAMPATH",
      "CAMPTOSAR",
      "CAMZYOS",
      "CANAGLIFLOZIN",
      "CANAGLIFLOZIN",
      " METFORMIN HYDROCHLORIDE",
      "CANASA",
      "CANCIDAS",
      "CANDESARTAN CILEXETIL",
      "CANDESARTAN CILEXETIL AND HYDROCHLOROTHIAZIDE",
      "CANDESARTAN CILEXETIL",
      " HYDROCHLOROTHIAZIDE",
      "CAPECITABINE",
      "CAPEX",
      "CAPITAL SOLEIL 15",
      "CAPLYTA",
      "CAPRELSA",
      "CAPTOPRIL",
      "CAPTOPRIL AND HYDROCHLOROTHIAZIDE",
      "CARAC",
      "CARAFATE",
      "CARBAGLU",
      "CARBAMAZEPINE",
      "CARBATROL",
      "CARBIDOPA",
      "CARBIDOPA AND LEVODOPA",
      "CARBIDOPA, LEVODOPA AND ENTACAPONE",
      "CARBIDOPA",
      " LEVODOPA",
      "CARBINOXAMINE MALEATE",
      "CARBOCAINE",
      "CARBON DIOXIDE, USP",
      "CARBOPLATIN",
      "CARBOPROST TROMETHAMINE",
      "CARDENE IN 0.83% SODIUM CHLORIDE IN PLASTIC CONTAINER",
      "CARDENE IN 0.86% SODIUM CHLORIDE IN PLASTIC CONTAINER",
      "CARDENE IN 4.8% DEXTROSE IN PLASTIC CONTAINER",
      "CARDIOGEN-82",
      "CARDIOLITE",
      "CARDIOPLEGIC IN PLASTIC CONTAINER",
      "CARDIZEM",
      "CARDIZEM CD",
      "CARDIZEM LA",
      "CARDURA",
      "CARDURA XL",
      "CARFILZOMIB",
      "CARGLUMIC ACID",
      "CARISOPRODOL",
      "CARMUSTINE",
      "CARNITOR",
      "CARNITOR SF",
      "CAROSPIR",
      "CARTEOLOL HYDROCHLORIDE",
      "CARTIA XT",
      "CARVEDILOL",
      "CARVEDILOL PHOSPHATE",
      "CASODEX",
      "CASPOFUNGIN ACETATE",
      "CASPORYN HC",
      "CATAFLAM",
      "CATAPRES-TTS-1",
      "CATAPRES-TTS-2",
      "CATAPRES-TTS-3",
      "CATHFLO ACTIVASE",
      "CAVERJECT",
      "CAVERJECT IMPULSE",
      "CAYSTON",
      "CEFACLOR",
      "CEFADROXIL",
      "CEFAZOLIN IN PLASTIC CONTAINER",
      "CEFAZOLIN SODIUM",
      "CEFDINIR",
      "CEFEPIME AND DEXTROSE IN DUPLEX CONTAINER",
      "CEFEPIME HYDROCHLORIDE",
      "CEFEPIME HYDROCHLORIDE IN PLASTIC CONTAINER",
      "CEFEPIME IN PLASTIC CONTAINER",
      "CEFIXIME",
      "CEFOTETAN",
      "CEFOXITIN",
      "CEFOXITIN AND DEXTROSE IN DUPLEX CONTAINER",
      "CEFOXITIN IN PLASTIC CONTAINER",
      "CEFPODOXIME PROXETIL",
      "CEFPROZIL",
      "CEFTAZIDIME",
      "CEFTRIAXONE",
      "CEFTRIAXONE AND DEXTROSE IN DUPLEX CONTAINER",
      "CEFTRIAXONE IN PLASTIC CONTAINER",
      "CEFTRIAXONE SODIUM",
      "CEFUROXIME",
      "CEFUROXIME AXETIL",
      "CEFUROXIME SODIUM",
      "CELEBREX",
      "CELECOXIB",
      "CELESTONE SOLUSPAN",
      "CELEXA",
      "CELLCEPT",
      "CELONTIN",
      "CENTANY",
      "CEPHALEXIN",
      "CEQUA",
      "CERDELGA",
      "CEREBYX",
      "CEREZYME",
      "CERIANNA",
      "CERUBIDINE",
      "CERVIDIL",
      "CESAMET",
      "CETIRIZINE HYDROCHLORIDE",
      "CETIRIZINE HYDROCHLORIDE ALLERGY",
      "CETIRIZINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
      "CETIRIZINE HYDROCHLORIDE HIVES",
      "CETIRIZINE HYDROCHLORIDE HIVES RELIEF",
      "CETRAXAL",
      "CETROTIDE",
      "CEVIMELINE HYDROCHLORIDE",
      "CHABELINA FE",
      "CHEMET",
      "CHENODIOL",
      "CHG SCRUB",
      "CHILDREN'S ADVIL",
      "CHILDREN'S ADVIL COLD",
      "CHILDREN'S ADVIL-FLAVORED",
      "CHILDREN'S ALAWAY",
      "CHILDREN'S ALLEGRA ALLERGY",
      "CHILDREN'S ASTEPRO ALLERGY",
      "CHILDREN'S CETIRIZINE HYDROCHLORIDE ALLERGY",
      "CHILDREN'S CETIRIZINE HYDROCHLORIDE HIVES RELIEF",
      "CHILDREN'S CLARITIN",
      "CHILDREN'S FEXOFENADINE HYDROCHLORIDE ALLERGY",
      "CHILDREN'S FEXOFENADINE HYDROCHLORIDE HIVES",
      "CHILDREN'S IBUPROFEN",
      "CHILDREN'S MOTRIN",
      "CHILDREN'S MOTRIN COLD",
      "CHILDREN'S ZYRTEC ALLERGY",
      "CHILDREN'S ZYRTEC HIVES RELIEF",
      "CHLORAMPHENICOL SODIUM SUCCINATE",
      "CHLORAPREP ONE-STEP",
      "CHLORAPREP ONE-STEP FREPP",
      "CHLORAPREP ONE-STEP SEPP",
      "CHLORAPREP SINGLE SWABSTICK",
      "CHLORAPREP TRIPLE SWABSTICK",
      "CHLORAPREP WITH TINT",
      "CHLORDIAZEPOXIDE AND AMITRIPTYLINE HYDROCHLORIDE",
      "CHLORDIAZEPOXIDE HYDROCHLORIDE",
      "CHLORDIAZEPOXIDE HYDROCHLORIDE AND CLIDINIUM BROMIDE",
      "CHLORHEXIDINE GLUCONATE",
      "CHLOROPROCAINE HYDROCHLORIDE",
      "CHLOROQUINE PHOSPHATE",
      "CHLOROTHIAZIDE SODIUM",
      "CHLORPHENIRAMINE MALEATE",
      "CHLORPROMAZINE HYDROCHLORIDE",
      "CHLORTHALIDONE",
      "CHLORZOXAZONE",
      "CHOLBAM",
      "CHOLESTYRAMINE",
      "CHOLESTYRAMINE LIGHT",
      "CHOLETEC",
      "CHOLINE C-11",
      "CHORIONIC GONADOTROPIN",
      "CHROMIC CHLORIDE IN PLASTIC CONTAINER",
      "CIALIS",
      "CIBINQO",
      "CICLOPIROX",
      "CIDA-STAT",
      "CIDOFOVIR",
      "CILOSTAZOL",
      "CILOXAN",
      "CIMDUO",
      "CIMERLI",
      "CIMETIDINE",
      "CIMETIDINE HYDROCHLORIDE",
      "CIMZIA",
      "CINACALCET HYDROCHLORIDE",
      "CINQAIR",
      "CINVANTI",
      "CIPRO",
      "CIPRO HC",
      "CIPRO XR",
      "CIPRODEX",
      "CIPROFLOXACIN",
      "CIPROFLOXACIN AND DEXAMETHASONE",
      "CIPROFLOXACIN EXTENDED RELEASE",
      "CIPROFLOXACIN HYDROCHLORIDE",
      "CIPROFLOXACIN IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "CIS-MDP",
      "CISATRACURIUM BESYLATE",
      "CISATRACURIUM BESYLATE PRESERVATIVE FREE",
      "CISPLATIN",
      "CITALOPRAM HYDROBROMIDE",
      "CITANEST FORTE DENTAL",
      "CITRIC ACID",
      " MAGNESIUM OXIDE",
      " SODIUM PICOSULFATE",
      "CLADRIBINE",
      "CLARAVIS",
      "CLARINEX",
      "CLARINEX-D 12 HOUR",
      "CLARISCAN",
      "CLARITHROMYCIN",
      "CLARITIN",
      "CLARITIN HIVES RELIEF",
      "CLARITIN HIVES RELIEF REDITAB",
      "CLARITIN REDITABS",
      "CLARITIN-D",
      "CLARITIN-D 24 HOUR",
      "CLEMASTINE FUMARATE",
      "CLENPIQ",
      "CLEOCIN",
      "CLEOCIN HYDROCHLORIDE",
      "CLEOCIN PHOSPHATE",
      "CLEOCIN T",
      "CLEVIPREX",
      "CLIMARA",
      "CLIMARA PRO",
      "CLINDA-DERM",
      "CLINDAMYCIN HYDROCHLORIDE",
      "CLINDAMYCIN PALMITATE HYDROCHLORIDE",
      "CLINDAMYCIN PHOSPHATE",
      "CLINDAMYCIN PHOSPHATE AND BENZOYL PEROXIDE",
      "CLINDAMYCIN PHOSPHATE AND TRETINOIN",
      "CLINDAMYCIN PHOSPHATE IN 0.9% SODIUM CHLORIDE",
      "CLINDAMYCIN PHOSPHATE IN 5% DEXTROSE IN PLASTIC CONTAINER",
      "CLINDAMYCIN PHOSPHATE IN DEXTROSE 5%",
      "CLINDESSE",
      "CLINDETS",
      "CLINIMIX 2.75/10 SULFITE FREE IN DEXTROSE 10% IN PLASTIC CONTAINER",
      "CLINIMIX 2.75/25 SULFITE FREE IN DEXTROSE 25% IN PLASTIC CONTAINER",
      "CLINIMIX 2.75/5 SULFITE FREE IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "CLINIMIX 4.25/10 SULFITE FREE IN DEXTROSE 10% IN PLASTIC CONTAINER",
      "CLINIMIX 4.25/20 SULFITE FREE IN DEXTROSE 20% IN PLASTIC CONTAINER",
      "CLINIMIX 4.25/25 SULFITE FREE IN DEXTROSE 25% IN PLASTIC CONTAINER",
      "CLINIMIX 4.25/5 SULFITE FREE IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "CLINIMIX 5/10 SULFITE FREE IN DEXTROSE 10% IN PLASTIC CONTAINER",
      "CLINIMIX 5/15 SULFITE FREE IN DEXTROSE 15% IN PLASTIC CONTAINER",
      "CLINIMIX 5/20 SULFITE FREE IN DEXTROSE 20% IN PLASTIC CONTAINER",
      "CLINIMIX 5/25 SULFITE FREE IN DEXTROSE 25% IN PLASTIC CONTAINER",
      "CLINIMIX 5/35 SULFITE FREE IN DEXTROSE 35% IN PLASTIC CONTAINER",
      "CLINIMIX E 2.75/10 SULFITE FREE W/ ELECT IN DEXTROSE 10% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 2.75/25 SULFITE FREE W/ ELECT IN DEXTROSE 25% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 2.75/5 SULFITE FREE W/ ELECT IN DEXTROSE 5% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 4.25/10 SULFITE FREE W/ ELECT IN DEXTROSE 10% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 4.25/20 SULFITE FREE W/ ELECT IN DEXTROSE 20% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 4.25/25 SULFITE FREE W/ ELECT IN DEXTROSE 25% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 4.25/5 SULFITE FREE W/ ELECT IN DEXTROSE 5% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 5/10 SULFITE FREE W/ ELECT IN DEXTROSE 10% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 5/15 SULFITE FREE W/ ELECT IN DEXTROSE 15% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 5/20 SULFITE FREE W/ ELECT IN 20% DEXTROSE W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 5/25 SULFITE FREE W/ ELECT IN DEXTROSE 25% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINIMIX E 5/35 SULFITE FREE W/ ELECT IN DEXTROSE 35% W/ CALCIUM IN PLASTIC CONTAINER",
      "CLINISOL 15% SULFITE FREE IN PLASTIC CONTAINER",
      "CLINOLIPID 20%",
      "CLOBAZAM",
      "CLOBETASOL PROPIONATE",
      "CLOBETASOL PROPIONATE (EMOLLIENT)",
      "CLOBEX",
      "CLOCORTOLONE PIVALATE",
      "CLODERM",
      "CLOFARABINE",
      "CLOLAR",
      "CLOMIPHENE CITRATE",
      "CLOMIPRAMINE HYDROCHLORIDE",
      "CLONAZEPAM",
      "CLONIDINE",
      "CLONIDINE HYDROCHLORIDE",
      "CLOPIDOGREL BISULFATE",
      "CLORAZEPATE DIPOTASSIUM",
      "CLOROTEKAL",
      "CLOTRIMAZOLE",
      "CLOTRIMAZOLE AND BETAMETHASONE DIPROPIONATE",
      "CLOZAPINE",
      "CLOZARIL",
      "COARTEM",
      "CODEINE SULFATE",
      "COL-PROBENECID",
      "COLAZAL",
      "COLCHICINE",
      "COLCRYS",
      "COLESEVELAM HYDROCHLORIDE",
      "COLESTID",
      "COLESTIPOL HYDROCHLORIDE",
      "COLISTIMETHATE SODIUM",
      "COLOCORT",
      "COLUMVI",
      "COLY-MYCIN M",
      "COLYTE WITH FLAVOR PACKS",
      "COMBIGAN",
      "COMBIPATCH",
      "COMBIVENT RESPIMAT",
      "COMBIVIR",
      "COMETRIQ",
      "COMPLERA",
      "COMPRO",
      "COMTAN",
      "CONCERTA",
      "CONDYLOX",
      "CONJUPRI",
      "CONRAY",
      "CONTRAVE",
      "CONZIP",
      "COPAXONE",
      "COPIKTRA",
      "CORDRAN",
      "COREG",
      "COREG CR",
      "CORGARD",
      "CORLANOR",
      "CORLOPAM",
      "CORMAX",
      "CORPHEDRA",
      "CORTEF",
      "CORTENEMA",
      "CORTIFOAM",
      "CORVERT",
      "COSELA",
      "COSENTYX",
      "COSMEGEN",
      "COSOPT",
      "COSOPT PF",
      "COSYNTROPIN",
      "COTELLIC",
      "COTEMPLA XR-ODT",
      "COZAAR",
      "CREON",
      "CRESEMBA",
      "CRESTOR",
      "CRINONE",
      "CROMOLYN SODIUM",
      "CROTAN",
      "CRYSELLE",
      "CRYSVITA",
      "CUPRIC CHLORIDE",
      "CUPRIC CHLORIDE IN PLASTIC CONTAINER",
      "CUPRIC SULFATE",
      "CUPRIMINE",
      "CUROSURF",
      "CUVPOSA",
      "CYANOCOBALAMIN",
      "CYANOKIT",
      "CYCLESSA",
      "CYCLOBENZAPRINE HYDROCHLORIDE",
      "CYCLOGYL",
      "CYCLOMYDRIL",
      "CYCLOPHOSPHAMIDE",
      "CYCLOSET",
      "CYCLOSPORINE",
      "CYKLOKAPRON",
      "CYLTEZO",
      "CYMBALTA",
      "CYONANZ",
      "CYPROHEPTADINE HYDROCHLORIDE",
      "CYRAMZA",
      "CYSTADANE",
      "CYSTADROPS",
      "CYSTAGON",
      "CYSTARAN",
      "CYSTO-CONRAY",
      "CYSTO-CONRAY II",
      "CYSTOGRAFIN",
      "CYSTOGRAFIN DILUTE",
      "CYSVIEW KIT",
      "CYTALUX",
      "CYTARABINE",
      "CYTOMEL",
      "CYTOTEC",
      "CYTOXAN",
      "DABIGATRAN ETEXILATE MESYLATE",
      "DACARBAZINE",
      "DACTINOMYCIN",
      "DALFAMPRIDINE",
      "DALIRESP",
      "DALVANCE",
      "DANAZOL",
      "DANTRIUM",
      "DANTROLENE SODIUM",
      "DANYELZA",
      "DAPAGLIFLOZIN",
      "DAPAGLIFLOZIN AND SAXAGLIPTIN",
      "DAPAGLIFLOZIN",
      "METFORMIN HYDROCHLORIDE",
      "DAPSONE",
      "DAPTOMYCIN",
      "DAPTOMYCIN IN 0.9% SODIUM CHLORIDE",
      "DARAPRIM",
      "DARIFENACIN",
      "DARIFENACIN HYDROBROMIDE",
      "DARUNAVIR",
      "DARUNAVIR ETHANOLATE",
      "DARZALEX",
      "DARZALEX FASPRO",
      "DASATINIB",
      "DASETTA 1/35",
      "DASETTA 7/7/7",
      "DATSCAN",
      "DAUNORUBICIN HYDROCHLORIDE",
      "DAURISMO",
      "DAXXIFY",
      "DAYBUE",
      "DAYPRO",
      "DAYSEE",
      "DAYTRANA",
      "DAYVIGO",
      "DDAVP",
      "DECITABINE",
      "DEFERASIROX",
      "DEFERIPRONE",
      "DEFEROXAMINE MESYLATE",
      "DEFINITY",
      "DEFINITY RT",
      "DEFITELIO",
      "DEFLAZACORT",
      "DELESTROGEN",
      "DELFLEX W/ DEXTROSE 1.5% IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 1.5% LOW MAGNESIUM IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 1.5% LOW MAGNESIUM LOW CALCIUM IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 2.5% IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 2.5% LOW MAGNESIUM IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 2.5% LOW MAGNESIUM LOW CALCIUM IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 4.25% IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 4.25% LOW MAGNESIUM IN PLASTIC CONTAINER",
      "DELFLEX W/ DEXTROSE 4.25% LOW MAGNESIUM LOW CALCIUM IN PLASTIC CONTAINER",
      "DELSTRIGO",
      "DELSYM",
      "DELZICOL",
      "DEMECLOCYCLINE HYDROCHLORIDE",
      "DEMEROL",
      "DEMSER",
      "DENAVIR",
      "DEOXYCHOLIC ACID",
      "DEPAKOTE",
      "DEPAKOTE ER",
      "DEPEN",
      "DEPO-ESTRADIOL",
      "DEPO-MEDROL",
      "DEPO-PROVERA",
      "DEPO-TESTOSTERONE",
      "DERMA-SMOOTHE/FS",
      "DERMABET",
      "DERMOTIC",
      "DESCOVY",
      "DESFERAL",
      "DESFLURANE",
      "DESIPRAMINE HYDROCHLORIDE",
      "DESLORATADINE",
      "DESLORATADINE AND PSEUDOEPHEDRINE SULFATE 24 HOUR",
      "DESMOPRESSIN ACETATE",
      "DESMOPRESSIN ACETATE (NEEDS NO REFRIGERATION)",
      "DESOGESTREL AND ETHINYL ESTRADIOL",
      "DESOGESTREL",
      " ETHINYL",
      "DESOGESTREL",
      " ETHINYL ESTRADIOL",
      "DESONIDE",
      "DESOWEN",
      "DESOXIMETASONE",
      "DESOXYN",
      "DESVENLAFAXINE",
      "DESVENLAFAXINE SUCCINATE",
      "DETECTNET",
      "DETROL",
      "DETROL LA",
      "DEXAMETHASONE",
      "DEXAMETHASONE INTENSOL",
      "DEXAMETHASONE SODIUM PHOSPHATE",
      "DEXAMETHASONE SODIUM PHOSPHATE PRESERVATIVE FREE",
      "DEXASPORIN",
      "DEXCHLORPHENIRAMINE MALEATE",
      "DEXEDRINE",
      "DEXILANT",
      "DEXLANSOPRAZOLE",
      "DEXMEDETOMIDINE HYDROCHLORIDE",
      "DEXMETHYLPHENIDATE HYDROCHLORIDE",
      "DEXRAZOXANE HYDROCHLORIDE",
      "DEXTENZA",
      "DEXTROAMP SACCHARATE, AMP ASPARTATE, DEXTROAMP SULFATE AND AMP SULFATE",
      "DEXTROAMPHETAMINE SACCHARATE",
      " AMPHETAMINE ASPARTATE MONOHYDRATE",
      " DEXTROAMPHETAMINE SULFATE",
      " AMPHETAMINE SULFATE",
      "DEXTROAMPHETAMINE SULFATE",
      "DEXTROMETHORPHAN HYDROBROMIDE AND QUINIDINE SULFATE",
      "DEXTROMETHORPHAN POLISTIREX",
      "DEXTROSE 10% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "DEXTROSE 10% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "DEXTROSE 10% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "DEXTROSE 10% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "DEXTROSE 10% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "DEXTROSE 10% IN PLASTIC CONTAINER",
      "DEXTROSE 2.5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "DEXTROSE 2.5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "DEXTROSE 2.5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "DEXTROSE 2.5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "DEXTROSE 2.5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "DEXTROSE 2.5% IN HALF-STRENGTH LACTATED RINGER'S IN PLASTIC CONTAINER",
      "DEXTROSE 20% IN PLASTIC CONTAINER",
      "DEXTROSE 25%",
      "DEXTROSE 3.3% AND SODIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "DEXTROSE 30% IN PLASTIC CONTAINER",
      "DEXTROSE 40% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND ELECTROLYTE NO. 48 IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND POTASSIUM CHLORIDE 0.075%",
      "DEXTROSE 5% AND POTASSIUM CHLORIDE 0.075% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND POTASSIUM CHLORIDE 0.15%",
      "DEXTROSE 5% AND POTASSIUM CHLORIDE 0.15% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND POTASSIUM CHLORIDE 0.224% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND POTASSIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.225% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.45%",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.9%",
      "DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "DEXTROSE 5% IN LACTATED RINGER'S IN PLASTIC CONTAINER",
      "DEXTROSE 5% IN PLASTIC CONTAINER",
      "DEXTROSE 5% IN SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "DEXTROSE 5% IN SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "DEXTROSE 5% IN SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "DEXTROSE 5% IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 10MEQ",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 15MEQ (K)",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 20MEQ",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 20MEQ (K)",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 30MEQ",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 40MEQ",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 5MEQ",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.2% AND POTASSIUM CHLORIDE 5MEQ (K)",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.33% AND POTASSIUM CHLORIDE 10MEQ IN PLASTIC CONTAINER",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.33% AND POTASSIUM CHLORIDE 15MEQ IN PLASTIC CONTAINER",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.33% AND POTASSIUM CHLORIDE 20MEQ IN PLASTIC CONTAINER",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.33% AND POTASSIUM CHLORIDE 30MEQ IN PLASTIC CONTAINER",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.33% AND POTASSIUM CHLORIDE 40MEQ IN PLASTIC CONTAINER",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.33% AND POTASSIUM CHLORIDE 5MEQ IN PLASTIC CONTAINER",
      "DEXTROSE 5%, SODIUM CHLORIDE 0.45% AND POTASSIUM CHLORIDE 20MEQ (K) IN PLASTIC CONTAINER",
      "DEXTROSE 50%",
      "DEXTROSE 50% IN PLASTIC CONTAINER",
      "DEXTROSE 70% IN PLASTIC CONTAINER",
      "DEXYCU KIT",
      "DHIVY",
      "DIABETA",
      "DIACOMIT",
      "DIANEAL LOW CALCIUM W/ DEXTROSE 1.5% IN PLASTIC CONTAINER",
      "DIANEAL LOW CALCIUM W/ DEXTROSE 2.5% IN PLASTIC CONTAINER",
      "DIANEAL LOW CALCIUM W/ DEXTROSE 4.25% IN PLASTIC CONTAINER",
      "DIANEAL LOW CALCIUM W/DEXTROSE 1.5% IN PLASTIC CONTAINER",
      "DIANEAL LOW CALCIUM W/DEXTROSE 2.5% IN PLASTIC CONTAINER",
      "DIANEAL LOW CALCIUM W/DEXTROSE 3.5% IN PLASTIC CONTAINER",
      "DIANEAL LOW CALCIUM W/DEXTROSE 4.25% IN PLASTIC CONTAINER",
      "DIANEAL PD-2 W/ DEXTROSE 1.5% IN PLASTIC CONTAINER",
      "DIANEAL PD-2 W/ DEXTROSE 2.5% IN PLASTIC CONTAINER",
      "DIANEAL PD-2 W/ DEXTROSE 4.25% IN PLASTIC CONTAINER",
      "DIASTAT",
      "DIASTAT ACUDIAL",
      "DIATRIZOATE MEGLUMINE AND DIATRIZOATE SODIUM",
      "DIAZEPAM",
      "DIAZEPAM INTENSOL",
      "DIAZOXIDE",
      "DIBENZYLINE",
      "DICHLORPHENAMIDE",
      "DICLEGIS",
      "DICLOFENAC",
      "DICLOFENAC POTASSIUM",
      "DICLOFENAC SODIUM",
      "DICLOFENAC SODIUM AND MISOPROSTOL",
      "DICLOXACILLIN SODIUM",
      "DICYCLOMINE HYDROCHLORIDE",
      "DICYCLOMINE HYDROCHLORIDE (PRESERVATIVE FREE)",
      "DIETHYLPROPION HYDROCHLORIDE",
      "DIFFERIN",
      "DIFICID",
      "DIFLORASONE DIACETATE",
      "DIFLUCAN",
      "DIFLUNISAL",
      "DIFLUPREDNATE",
      "DIGOXIN",
      "DIHYDROERGOTAMINE MESYLATE",
      "DILANTIN",
      "DILANTIN-125",
      "DILAUDID",
      "DILTIAZEM HYDROCHLORIDE",
      "DIMENHYDRINATE",
      "DIMETHYL FUMARATE",
      "DIOVAN",
      "DIOVAN HCT",
      "DIPENTUM",
      "DIPHENHYDRAMINE HYDROCHLORIDE",
      "DIPHENHYDRAMINE HYDROCHLORIDE PRESERVATIVE FREE",
      "DIPHENOXYLATE HYDROCHLORIDE AND ATROPINE SULFATE",
      "DIPRIVAN",
      "DIPYRIDAMOLE",
      "DISOPYRAMIDE PHOSPHATE",
      "DISULFIRAM",
      "DITROPAN XL",
      "DIURIL",
      "DIVALPROEX SODIUM",
      "DIVIGEL",
      "DOBUTAMINE HYDROCHLORIDE",
      "DOBUTAMINE HYDROCHLORIDE IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "DOCETAXEL",
      "DOCOSANOL",
      "DODEX",
      "DOFETILDE",
      "DOFETILIDE",
      "DOLISHALE",
      "DOLUTEGRAVIR",
      "DOLUTEGRAVIR LAMIVUDINE TENOFOVIR ALAFENAMIDE",
      "DOLUTEGRAVIR SODIUM",
      "DOLUTEGRAVIR, EMTRICITABINE and TENOFOVIR ALAFENAMIDE",
      "DOLUTEGRAVIR, LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
      "DOLUTEGRAVIR",
      " EMTRICITABINE",
      " TENOFOVIR ALAFENAMIDE",
      "DOLUTEGRAVIR",
      " LAMIVUDINE",
      " TENOFOVIR DISOPROXIL FUMARATE",
      "DOLUTEGRAVIR",
      " RILPIVIRINE",
      "DOLUTEGRAVIR",
      "EMTRICITABINE",
      "TENOFOVIR ALAFENAMIDE",
      "DONEPEZIL HYDROCHLORIDE",
      "DONEPEZIL HYDROCHLORIDE AND MEMANTINE HYDROCHLORIDE",
      "DOPAMINE HYDROCHLORIDE",
      "DOPAMINE HYDROCHLORIDE IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "DOPRAM",
      "DOPTELET",
      "DORAL",
      "DORYX",
      "DORYX MPC",
      "DORZOLAMIDE HYDROCHLORIDE",
      "DORZOLAMIDE HYDROCHLORIDE AND TIMOLOL MALEATE",
      "DOTAREM",
      "DOVATO",
      "DOVONEX",
      "DOXAPRAM HYDROCHLORIDE",
      "DOXAZOSIN MESYLATE",
      "DOXEPIN HYDROCHLORIDE",
      "DOXERCALCIFEROL",
      "DOXIL (LIPOSOMAL)",
      "DOXORUBICIN HYDROCHLORIDE",
      "DOXORUBICIN HYDROCHLORIDE (LIPOSOMAL)",
      "DOXY 100",
      "DOXY 200",
      "DOXYCYCLINE",
      "DOXYCYCLINE HYCLATE",
      "DOXYLAMINE SUCCINATE",
      "DOXYLAMINE SUCCINATE AND PYRIDOXINE HYDROCHLORIDE",
      "DRAX EXAMETAZIME",
      "DRAXIMAGE DTPA",
      "DRAXIMAGE MDP-25",
      "DRONABINOL",
      "DRONEDARONE",
      "DRONEDARONE HYDROCHLORIDE",
      "DROPERIDOL",
      "DROSPIRENONE",
      "DROSPIRENONE AND ETHINYL ESTRADIOL",
      "DROSPIRENONE, ETHINYL ESTRADIOL AND LEVOMEFOLATE CALCIUM",
      "DROXIA",
      "DROXIDOPA",
      "DSUVIA",
      "DUAC",
      "DUAKLIR PRESSAIR",
      "DUAVEE",
      "DUETACT",
      "DUEXIS",
      "DULERA",
      "DULOXETINE HYDROCHLORIDE",
      "DUOBRII",
      "DUOPA",
      "DUPIXENT",
      "DURACLON",
      "DURAMORPH PF",
      "DUREZOL",
      "DURLAZA",
      "DURYSTA",
      "DUTASTERIDE",
      "DUTASTERIDE AND TAMSULOSIN HYDROCHLORIDE",
      "DUVOID",
      "DYANAVEL XR",
      "DYANAVEL XR 10",
      "DYANAVEL XR 15",
      "DYANAVEL XR 20",
      "DYANAVEL XR 5",
      "DYCLOPRO",
      "DYMISTA",
      "DYNACIN",
      "DYRENIUM",
      "DYSPORT",
      "E-Z SCRUB 201",
      "E-Z SCRUB 241",
      "E-Z-HD",
      "E-Z-PAQUE",
      "E.E.S.",
      "E.E.S. 400",
      "EBANGA",
      "EC-NAPROSYN",
      "ECONAZOLE NITRATE",
      "ECOZA",
      "EDARBI",
      "EDARBYCLOR",
      "EDECRIN",
      "EDETATE CALCIUM DISODIUM",
      "EDEX",
      "EDLUAR",
      "EDOXABAN",
      "EDURANT",
      "EFAVIRENZ",
      "EFAVIRENZ 200MG SCORED TABLETS",
      "EFAVIRENZ, EMTRICITABINE, AND TENOFOVIR DISOPROXIL FUMARATE",
      "EFAVIRENZ, LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
      "EFAVIRENZ, LAMIVUDINE, AND TENOFOVIR DISOPROXIL FUMARATE",
      "EFAVIRENZ",
      " EMTRICITABINE",
      " TENOFOVIR DISOPROXIL FUMARATE",
      "EFAVIRENZ",
      " LAMIVUDINE",
      " TENOFOVIR DISOPROXIL FUMARATE",
      "EFFEXOR XR",
      "EFFIENT",
      "EFINACONAZOLE",
      "EFUDEX",
      "EGATEN",
      "EGRIFTA",
      "ELAPRASE",
      "ELCYS",
      "ELELYSO",
      "ELEPSIA XR",
      "ELESTRIN",
      "ELETRIPTAN HYDROBROMIDE",
      "ELFABRIO",
      "ELIDEL",
      "ELIGARD KIT",
      "ELIGLUSTAT TARTRATE",
      "ELINEST",
      "ELIQUIS",
      "ELITEK",
      "ELIXOPHYLLIN",
      "ELLA",
      "ELLIOTTS B SOLUTION",
      "ELMIRON",
      "ELOXATIN",
      "ELREXFIO",
      "ELSPAR",
      "ELTROMBOPAG",
      "ELUCIREM",
      "ELURYNG",
      "ELUXADOLINE",
      "ELZONRIS",
      "EMBELINE",
      "EMEND",
      "EMERPHED",
      "EMFLAZA",
      "EMGALITY",
      "EMPAGLIFLOZIN",
      "EMPAGLIFLOZIN AND LINAGLIPTIN",
      "EMPAGLIFLOZIN METFORMIN HYDROCHLORIDE",
      "EMPAGLIFLOZIN",
      " LINAGLIPTIN",
      "EMPAGLIFLOZIN",
      "METFORMIN HYDROCHLORIDE",
      "EMPAVELI",
      "EMPLICITI",
      "EMSAM",
      "EMTRICITABINE",
      "EMTRICITABINE AND  TENOFOVIR DISOPROXIL FUMARATE",
      "EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
      "EMTRICITABINE",
      " RILPIVIRINE",
      " TENOFOVIR ALAFENAMIDE",
      "EMTRICITABINE",
      " TENOFOVIR ALAFENAMIDE",
      "EMTRICITABINE",
      " TENOFOVIR DISOPROXIL FUMARATE",
      "EMTRICITABINE",
      "RILPIVIRINE",
      "TENOFOVIR DISOPROXIL FUMARATE",
      "EMTRICITABINE",
      "TENOFOVIR DISOPROXIL FUMARATE",
      "NEVIRAPINE",
      "EMTRIVA",
      "EMVERM",
      "EMZAHH",
      "ENALAPRIL MALEATE",
      "ENALAPRIL MALEATE AND HYDROCHLOROTHIAZIDE",
      "ENALAPRILAT",
      "ENBREL",
      "ENDARI",
      "ENDOMETRIN",
      "ENHERTU",
      "ENILLORING",
      "ENJAYMO",
      "ENOXAPARIN SODIUM",
      "ENOXAPARIN SODIUM (PRESERVATIVE FREE)",
      "ENPRESSE-28",
      "ENSPRYNG",
      "ENSTILAR",
      "ENTACAPONE",
      "ENTADFI",
      "ENTECAVIR",
      "ENTERO VU 24%",
      "ENTOCORT EC",
      "ENTRESTO",
      "ENTYVIO",
      "ENVARSUS XR",
      "ENZALUTAMIDE",
      "EOVIST",
      "EPANED",
      "EPCLUSA",
      "EPHEDRINE SULFATE",
      "EPIDIOLEX",
      "EPIDUO",
      "EPIDUO FORTE",
      "EPIFOAM",
      "EPINASTINE HYDROCHLORIDE",
      "EPINEPHRINE",
      "EPINEPHRINE (AUTOINJECTOR)",
      "EPINEPHRINE IN 0.9% SODIUM CHLORIDE",
      "EPIPEN",
      "EPIPEN JR.",
      "EPIRUBICIN HYDROCHLORIDE",
      "EPITOL",
      "EPIVIR",
      "EPIVIR-HBV",
      "EPLERENONE",
      "EPOGEN/PROCRIT",
      "EPOPROSTENOL",
      "EPOPROSTENOL SODIUM",
      "EPRONTIA",
      "EPSOLAY",
      "EPTIFIBATIDE",
      "EPZICOM",
      "EQUETRO",
      "ERAXIS",
      "ERBITUX",
      "ERELZI",
      "ERGOCALCIFEROL",
      "ERGOLOID MESYLATES",
      "ERGOMAR",
      "ERGOTAMINE TARTRATE AND CAFFEINE",
      "ERIVEDGE",
      "ERLEADA",
      "ERLOTINIB HYDROCHLORIDE",
      "ERMEZA",
      "ERRIN",
      "ERTACZO",
      "ERTAPENEM SODIUM",
      "ERTUGLIFLOZIN",
      "ERY-TAB",
      "ERYC",
      "ERYGEL",
      "ERYPED",
      "ERYTHRA-DERM",
      "ERYTHROCIN",
      "ERYTHROCIN STEARATE",
      "ERYTHROMYCIN",
      "ERYTHROMYCIN AND BENZOYL PEROXIDE",
      "ERYTHROMYCIN ETHYLSUCCINATE",
      "ERYTHROMYCIN LACTOBIONATE",
      "ESBRIET",
      "ESCITALOPRAM",
      "ESCITALOPRAM OXALATE",
      "ESLICARBAZEPINE ACETATE",
      "ESMOLOL HYDROCHLORIDE",
      "ESMOLOL HYDROCHLORIDE DOUBLE STRENGTH IN PLASTIC CONTAINER",
      "ESMOLOL HYDROCHLORIDE IN PLASTIC CONTAINER",
      "ESOMEPRAZOLE MAGNESIUM",
      "ESOMEPRAZOLE SODIUM",
      "ESTARYLLA",
      "ESTAZOLAM",
      "ESTRACE",
      "ESTRADIOL",
      "ESTRADIOL AND NORETHINDRONE ACETATE",
      "ESTRADIOL AND NORGESTIMATE",
      "ESTRADIOL VALERATE",
      "ESTRADIOL VALERATE",
      " ESTRADIOL VALERATE",
      " DIENOGEST",
      "ESTRING",
      "ESTROGEL",
      "ESZOPICLONE",
      "ETHACRYNATE SODIUM",
      "ETHACRYNIC ACID",
      "ETHAMBUTOL HYDROCHLORIDE",
      "ETHAMOLIN",
      "ETHINYL ESTRADIOL AND LEVONORGESTREL",
      "ETHINYL ESTRADIOL AND NORELGESTROMIN",
      "ETHINYL ESTRADIOL",
      " ETONOGESTREL",
      "ETHOSUXIMIDE",
      "ETHYNODIOL DIACETATE AND ETHINYL ESTRADIOL",
      "ETHYOL",
      "ETICOVO",
      "ETODOLAC",
      "ETOMIDATE",
      "ETOPOPHOS PRESERVATIVE FREE",
      "ETOPOSIDE",
      "ETRAVIRINE",
      "EUCRISA",
      "EURAX",
      "EUTHYROX",
      "EVAMIST",
      "EVEKEO",
      "EVEKEO ODT",
      "EVENITY",
      "EVEROLIMUS",
      "EVISTA",
      "EVKEEZA",
      "EVOMELA",
      "EVOTAZ",
      "EVOXAC",
      "EVRYSDI",
      "EXCEDRIN (MIGRAINE RELIEF)",
      "EXELDERM",
      "EXELON",
      "EXEM FOAM KIT",
      "EXEMESTANE",
      "EXFORGE",
      "EXFORGE HCT",
      "EXIDINE",
      "EXJADE",
      "EXKIVITY",
      "EXONDYS 51",
      "EXPAREL",
      "EXSERVAN",
      "EXTAVIA",
      "EXTENDED PHENYTOIN SODIUM",
      "EXTINA",
      "EXTRANEAL",
      "EYLEA",
      "EYLEA HD",
      "EYSUVIS",
      "EZALLOR SPRINKLE",
      "EZETIMIBE",
      "EZETIMIBE AND SIMVASTATIN",
      "FABIOR",
      "FABRAZYME",
      "FALLBACK SOLO",
      "FALMINA",
      "FAMCICLOVIR",
      "FAMOTIDINE",
      "FAMOTIDINE PRESERVATIVE FREE",
      "FAMOTIDINE PRESERVATIVE FREE IN PLASTIC CONTAINER",
      "FAMOTIDINE, CALCIUM CARBONATE, AND MAGNESIUM HYDROXIDE",
      "FANAPT",
      "FARESTON",
      "FASENRA",
      "FASLODEX",
      "FEBUXOSTAT",
      "FELBAMATE",
      "FELBATOL",
      "FELDENE",
      "FELODIPINE",
      "FEMARA",
      "FEMHRT",
      "FEMRING",
      "FENOFIBRATE",
      "FENOFIBRATE (MICRONIZED)",
      "FENOFIBRIC ACID",
      "FENOGLIDE",
      "FENOLDOPAM MESYLATE",
      "FENOPROFEN CALCIUM",
      "FENSOLVI KIT",
      "FENTANYL",
      "FENTANYL CITRATE",
      "FENTANYL CITRATE PRESERVATIVE FREE",
      "FENTANYL-100",
      "FENTANYL-12",
      "FENTANYL-25",
      "FENTANYL-37",
      "FENTANYL-50",
      "FENTANYL-62",
      "FENTANYL-75",
      "FENTANYL-87",
      "FENTORA",
      "FERAHEME",
      "FERRIPROX",
      "FERRLECIT",
      "FERROUS FUMARATE",
      "FERUMOXYTOL",
      "FESOTERODINE FUMARATE",
      "FETROJA",
      "FETZIMA",
      "FEXINIDAZOLE",
      "FEXOFENADINE HCL",
      " PSEUDOEPHEDRINE HCL",
      "FEXOFENADINE HYDROCHLORIDE",
      "FEXOFENADINE HYDROCHLORIDE ALLERGY",
      "FEXOFENADINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
      "FEXOFENADINE HYDROCHLORIDE HIVES",
      "FEXOFENADINE HYDROCHLORIDE",
      " PSEUDOEPHEDRINE HYDROCHLORIDE",
      "FIASP",
      "FIASP FLEXTOUCH",
      "FIASP PENFILL",
      "FINACEA",
      "FINASTERIDE",
      "FINGOLIMOD",
      "FINGOLIMOD HYDROCHLORIDE",
      "FINTEPLA",
      "FINZALA",
      "FIORICET W/ CODEINE",
      "FIRAZYR",
      "FIRDAPSE",
      "FIRMAGON",
      "FIRVANQ KIT",
      "FLAC",
      "FLAGYL",
      "FLAGYL I.V. RTU IN PLASTIC CONTAINER",
      "FLAREX",
      "FLAVORED COLESTID",
      "FLAVOXATE HYDROCHLORIDE",
      "FLECAINIDE ACETATE",
      "FLECTOR",
      "FLEQSUVY",
      "FLOLAN",
      "FLOLIPID",
      "FLOMAX",
      "FLONASE ALLERGY RELIEF",
      "FLONASE SENSIMIST ALLERGY RELIEF",
      "FLOVENT DISKUS 100",
      "FLOVENT DISKUS 250",
      "FLOVENT DISKUS 50",
      "FLOVENT HFA",
      "FLOXURIDINE",
      "FLUCINOLONE ACETONIDE",
      "FLUCONAZOLE",
      "FLUCONAZOLE IN SODIUM CHLORIDE 0.9%",
      "FLUCONAZOLE IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "FLUCYTOSINE",
      "FLUDARABINE PHOSPHATE",
      "FLUDEOXYGLUCOSE F18",
      "FLUDROCORTISONE ACETATE",
      "FLUMADINE",
      "FLUMAZENIL",
      "FLUNISOLIDE",
      "FLUOCINOLONE ACETONIDE",
      "FLUOCINONIDE",
      "FLUOCINONIDE ACETONIDE",
      "FLUOCINONIDE EMULSIFIED BASE",
      "FLUORESCEIN SODIUM AND BENOXINATE HYDROCHLORIDE",
      "FLUORODOPA F18",
      "FLUOROURACIL",
      "FLUOXETINE HYDROCHLORIDE",
      "FLUPHENAZINE DECANOATE",
      "FLUPHENAZINE HYDROCHLORIDE",
      "FLURANDRENOLIDE",
      "FLURAZEPAM HYDROCHLORIDE",
      "FLURBIPROFEN",
      "FLURBIPROFEN SODIUM",
      "FLUTAMIDE",
      "FLUTICASONE PROPIONATE",
      "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
      "FLUVASTATIN SODIUM",
      "FLUVOXAMINE MALEATE",
      "FML",
      "FML FORTE",
      "FOCALIN",
      "FOCALIN XR",
      "FOCINVEZ",
      "FOLIC ACID",
      "FOLLISTIM AQ",
      "FOLOTYN",
      "FOMEPIZOLE",
      "FONDAPARINUX SODIUM",
      "FORFIVO XL",
      "FORMOTEROL FUMARATE",
      "FORTAMET",
      "FORTEO",
      "FORTESTA",
      "FOSAMAX",
      "FOSAMAX PLUS D",
      "FOSAMPRENAVIR CALCIUM",
      "FOSAPREPITANT DIMEGLUMINE",
      "FOSCARNET SODIUM",
      "FOSCAVIR",
      "FOSFOMYCIN TROMETHAMINE",
      "FOSINOPRIL SODIUM",
      "FOSINOPRIL SODIUM AND HYDROCHLOROTHIAZIDE",
      "FOSPHENYTOIN SODIUM",
      "FOSRENOL",
      "FOTIVDA",
      "FRAGMIN",
      "FROVA",
      "FROVATRIPTAN SUCCINATE",
      "FULPHILA",
      "FULVESTRANT",
      "FULVICIN P/G",
      "FULVICIN P/G 165",
      "FULVICIN P/G 330",
      "FULVICIN-U/F",
      "FURADANTIN",
      "FUROSCIX",
      "FUROSEMIDE",
      "FUSILEV",
      "FUZEON",
      "FYARRO",
      "FYAVOLV",
      "FYCOMPA",
      "FYLNETRA",
      "FYREMADEL",
      "GABAPENTIN",
      "GABAPENTIN ENCARBIL",
      "GABITRIL",
      "GABLOFEN",
      "GADAVIST",
      "GADOBUTROL",
      "GADOTERATE MEGLUMINE",
      "GALAFOLD",
      "GALANTAMINE HYDROBROMIDE",
      "GALLIUM CITRATE GA 67",
      "GALLIUM GA 68 DOTATOC",
      "GALLIUM GA 68 GOZETOTIDE",
      "GALZIN",
      "GAMIFANT",
      "GANCICLOVIR SODIUM",
      "GANIRELIX ACETATE",
      "GANZYK-RTU",
      "GASTROCROM",
      "GASTROGRAFIN",
      "GATIFLOXACIN",
      "GATTEX KIT",
      "GAVRETO",
      "GAZYVA",
      "GEFITINIB",
      "GELNIQUE",
      "GEMCITABINE",
      "GEMCITABINE HYDROCHLORIDE",
      "GEMFIBROZIL",
      "GEMMILY",
      "GEMTESA",
      "GENERLAC",
      "GENGRAF",
      "GENOSYL",
      "GENOTROPIN",
      "GENOTROPIN PRESERVATIVE FREE",
      "GENTAMICIN SULFATE",
      "GENTAMICIN SULFATE IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "GENVOYA",
      "GEODON",
      "GIAPREZA",
      "GILDAGIA",
      "GILDESS 24 FE",
      "GILENYA",
      "GILOTRIF",
      "GIMOTI",
      "GIVLAARI",
      "GLATIRAMER ACETATE",
      "GLATOPA",
      "GLEOLAN",
      "GLEOSTINE",
      "GLIADEL",
      "GLIMEPIRIDE",
      "GLIPIZIDE",
      "GLIPIZIDE AND METFORMIN HYDROCHLORIDE",
      "GLOFIL-125",
      "GLOPERBA",
      "GLUCAGON",
      "GLUCOTROL XL",
      "GLUMETZA",
      "GLYBURIDE",
      "GLYBURIDE (MICRONIZED)",
      "GLYBURIDE AND METFORMIN HYDROCHLORIDE",
      "GLYCINE 1.5% IN PLASTIC CONTAINER",
      "GLYCOPYRROLATE",
      "GLYDO",
      "GLYNASE",
      "GLYRX-PF",
      "GLYSET",
      "GLYXAMBI",
      "GOCOVRI",
      "GOLYTELY",
      "GONAL-F",
      "GONAL-F RFF",
      "GONAL-F RFF REDI-JECT",
      "GOPRELTO",
      "GRALISE",
      "GRANISETRON HYDROCHLORIDE",
      "GRANISETRON HYDROCHLORIDE PRESERVATIVE FREE",
      "GRANIX",
      "GRIS-PEG",
      "GRISEOFULVIN",
      "GRISEOFULVIN, ULTRAMICROSIZE",
      "GRISEOFULVIN,ULTRAMICROSIZE",
      "GUAIFENESIN",
      "GUAIFENESIN AND DEXTROMETHORPHAN HYDROBROMIDE",
      "GUAIFENESIN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
      "GUANFACINE HYDROCHLORIDE",
      "GVOKE HYPOPEN",
      "GVOKE KIT",
      "GVOKE PFS",
      "GYNAZOLE-1",
      "H.P. ACTHAR GEL",
      "HABITROL",
      "HADLIMA",
      "HAILEY 1.5/30",
      "HAILEY 24 FE",
      "HAILEY FE 1.5/30",
      "HAILEY FE 1/20",
      "HALAVEN",
      "HALCINONIDE",
      "HALCION",
      "HALDOL",
      "HALOBETASOL PROPIONATE",
      "HALOBETASOL PROPIONATE",
      " TAZAROTENE",
      "HALOETTE",
      "HALOG",
      "HALOPERIDOL",
      "HALOPERIDOL DECANOATE",
      "HARVONI",
      "HEATHER",
      "HECTOROL",
      "HELIUM, USP",
      "HEMABATE",
      "HEMADY",
      "HEMANGEOL",
      "HEMLIBRA",
      "HEPARIN SODIUM",
      "HEPARIN SODIUM 1,000 UNITS AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM 1,000 UNITS IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM 10,000 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM 12,500 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM 2,000 UNITS AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM 2,000 UNITS IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM 20,000 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM 25,000 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "HEPARIN SODIUM IN PLASTIC CONTAINER",
      "HEPARIN SODIUM PRESERVATIVE FREE",
      "HEPSERA",
      "HEPZATO",
      "HER STYLE",
      "HERCEPTIN",
      "HERCEPTIN HYLECTA",
      "HERZUMA",
      "HETLIOZ",
      "HETLIOZ LQ",
      "HIBICLENS",
      "HIBISTAT",
      "HICON",
      "HIPREX",
      "HOMATROPINE METHYLBROMIDE AND HYDROCODONE BITARTRATE",
      "HORIZANT",
      "HULIO",
      "HUMALOG",
      "HUMALOG KWIKPEN",
      "HUMALOG MIX 50/50",
      "HUMALOG MIX 50/50 KWIKPEN",
      "HUMALOG MIX 75/25",
      "HUMALOG MIX 75/25 KWIKPEN",
      "HUMALOG TEMPO PEN",
      "HUMATROPE",
      "HUMIRA",
      "HUMULIN 70/30",
      "HUMULIN 70/30 PEN",
      "HUMULIN N",
      "HUMULIN R",
      "HUMULIN R KWIKPEN",
      "HUMULIN R PEN",
      "HYCAMTIN",
      "HYCODAN",
      "HYDRA-ZIDE",
      "HYDRALAZINE HYDROCHLORIDE",
      "HYDREA",
      "HYDROCHLOROTHIAZIDE",
      "HYDROCHLOROTHIAZIDE",
      " IRBESARTAN",
      "HYDROCHLOROTHIAZIDE",
      " VALSARTAN",
      "HYDROCODONE",
      "HYDROCODONE BITARTRATE",
      "HYDROCODONE BITARTRATE AND ACETAMINOPHEN",
      "HYDROCODONE BITARTRATE AND ASPIRIN",
      "HYDROCODONE BITARTRATE AND HOMATROPINE METHYLBROMIDE",
      "HYDROCODONE BITARTRATE AND IBUPROFEN",
      "HYDROCODONE BITARTRATE, CHLORPHENIRAMINE MALEATE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
      "HYDROCODONE POLISTIREX AND CHLORPHENIRAMINE POLISTIREX",
      "HYDROCORTISONE",
      "HYDROCORTISONE AND ACETIC ACID",
      "HYDROCORTISONE BUTYRATE",
      "HYDROCORTISONE IN ABSORBASE",
      "HYDROCORTISONE VALERATE",
      "HYDROMORPHONE HYDROCHLORIDE",
      "HYDROXOCOBALAMIN",
      "HYDROXYCHLOROQUINE SULFATE",
      "HYDROXYUREA",
      "HYDROXYZINE HYDROCHLORIDE",
      "HYDROXYZINE PAMOATE",
      "HYFTOR",
      "HYLENEX RECOMBINANT",
      "HYRIMOZ",
      "HYSINGLA ER",
      "HYZAAR",
      "IBANDRONATE SODIUM",
      "IBRANCE",
      "IBRUTINIB",
      "IBSRELA",
      "IBUPROFEN",
      "IBUPROFEN AND DIPHENHYDRAMINE CITRATE",
      "IBUPROFEN AND DIPHENHYDRAMINE HYDROCHLORIDE",
      "IBUPROFEN AND FAMOTIDINE",
      "IBUPROFEN AND PHENYLEPHRINE HYDROCHLORIDE",
      "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
      "IBUPROFEN LYSINE",
      "IBUPROHM COLD AND SINUS",
      "IBUTILIDE FUMARATE",
      "IC-GREEN",
      "ICATIBANT ACETATE",
      "ICLEVIA",
      "ICLUSIG",
      "ICOSAPENT ETHYL",
      "IDACIO",
      "IDAMYCIN PFS",
      "IDARUBICIN HYDROCHLORIDE",
      "IDARUBICIN HYDROCHLORIDE PFS",
      "IDHIFA",
      "IDKIT:HP",
      "IFEX",
      "IFOSFAMIDE",
      "IGALMI",
      "IHEEZO",
      "ILARIS",
      "ILEVRO",
      "ILLUCCIX",
      "ILOPERIDONE",
      "ILUMYA",
      "ILUVIEN",
      "IMATINIB MESYLATE",
      "IMBRUVICA",
      "IMCIVREE",
      "IMFINZI",
      "IMIPENEM AND CILASTATIN",
      "IMIPRAMINE HYDROCHLORIDE",
      "IMIPRAMINE PAMOATE",
      "IMIQUIMOD",
      "IMITREX",
      "IMITREX STATDOSE",
      "IMJUDO",
      "IMMPHENTIV",
      "IMODIUM A-D",
      "IMODIUM MULTI-SYMPTOM RELIEF",
      "IMPAVIDO",
      "IMPEKLO",
      "IMPOYZ",
      "IMURAN",
      "IMVEXXY",
      "INBRIJA",
      "INCASSIA",
      "INCRELEX",
      "INCRUSE ELLIPTA",
      "INDAPAMIDE",
      "INDERAL LA",
      "INDIUM IN 111 CHLORIDE",
      "INDIUM IN 111 OXYQUINOLINE",
      "INDOCYANINE GREEN",
      "INDOMETHACIN",
      "INDOMETHACIN SODIUM",
      "INFANT'S ADVIL",
      "INFANTS' FEVERALL",
      "INFASURF PRESERVATIVE FREE",
      "INFED",
      "INFLECTRA",
      "INFUMORPH",
      "INFUVITE ADULT",
      "INFUVITE PEDIATRIC",
      "INFUVITE PEDIATRIC (PHARMACY BULK PACKAGE)",
      "INGENOL MEBUTATE",
      "INGREZZA",
      "INJECTAFER",
      "INLYTA",
      "INMAZEB",
      "INNOPRAN XL",
      "INOMAX",
      "INPEFA",
      "INQOVI",
      "INREBIC",
      "INSPRA",
      "INTELENCE",
      "INTRALIPID 10%",
      "INTRALIPID 20%",
      "INTRALIPID 30%",
      "INTRAROSA",
      "INTRON A",
      "INTROVALE",
      "INTUNIV",
      "INVANZ",
      "INVEGA",
      "INVEGA HAFYERA",
      "INVEGA SUSTENNA",
      "INVEGA TRINZA",
      "INVELTYS",
      "INVOKAMET",
      "INVOKAMET XR",
      "INVOKANA",
      "IODIXANOL",
      "IOFLUPANE I-123",
      "IONOSOL MB AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "IOPAMIDOL",
      "IOPIDINE",
      "IPRATROPIUM BROMIDE",
      "IRBESARTAN",
      "IRBESARTAN AND HYDROCHLOROTHIAZIDE",
      "IRBESARTAN HYDROCHLOROTHIAZIDE",
      "IRBESARTAN",
      " HYDROCHLOROTHIAZIDE",
      "IRESSA",
      "IRINOTECAN HYDROCHLORIDE",
      "ISENTRESS",
      "ISENTRESS HD",
      "ISIBLOOM",
      "ISOFLURANE",
      "ISOLYTE P IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "ISOLYTE S IN PLASTIC CONTAINER",
      "ISOLYTE S PH 7.4 IN PLASTIC CONTAINER",
      "ISONIAZID",
      "ISOPROTERENOL HYDROCHLORIDE",
      "ISOPTO ATROPINE",
      "ISOPTO CARPINE",
      "ISORDIL",
      "ISOSORBIDE DINITRATE",
      "ISOSORBIDE DINITRATE AND HYDRALAZINE HYDROCHLORIDE",
      "ISOSORBIDE MONONITRATE",
      "ISOSULFAN BLUE",
      "ISOTRETINOIN",
      "ISOVUE-300",
      "ISOVUE-370",
      "ISRADIPINE",
      "ISTALOL",
      "ISTODAX",
      "ISTURISA",
      "ITRACONAZOLE",
      "IVABRADINE HYDROCHLORIDE",
      "IVACAFTOR",
      "IVERMECTIN",
      "IVY BLOCK",
      "IXEMPRA KIT",
      "IXIFI",
      "IYUZEH",
      "IZERVAY",
      "JADENU",
      "JADENU SPRINKLE",
      "JAIMIESS",
      "JAKAFI",
      "JALYN",
      "JANTOVEN",
      "JANUMET",
      "JANUMET XR",
      "JANUVIA",
      "JARDIANCE",
      "JATENZO",
      "JAYPIRCA",
      "JEANATOPE",
      "JELMYTO",
      "JEMPERLI",
      "JENCYCLA",
      "JENTADUETO",
      "JENTADUETO XR",
      "JESDUVROQ",
      "JETREA",
      "JEUVEAU",
      "JEVTANA KIT",
      "JOENJA",
      "JUBLIA",
      "JULUCA",
      "JUNEL 1.5/30",
      "JUNEL 1/20",
      "JUNEL FE 1.5/30",
      "JUNEL FE 1/20",
      "JUNIOR STRENGTH ADVIL",
      "JUNIOR STRENGTH MOTRIN",
      "JUXTAPID",
      "JYLAMVO",
      "JYNARQUE",
      "KABIVEN IN PLASTIC CONTAINER",
      "KADCYLA",
      "KALBITOR",
      "KALETRA",
      "KALEXATE",
      "KALLIGA",
      "KALYDECO",
      "KANJINTI",
      "KANUMA",
      "KAPSPARGO SPRINKLE",
      "KARBINAL ER",
      "KARIVA",
      "KATERZIA",
      "KAZANO",
      "KELNOR",
      "KENALOG-10",
      "KENALOG-40",
      "KENALOG-80",
      "KENGREAL",
      "KEPIVANCE",
      "KEPPRA",
      "KEPPRA XR",
      "KERENDIA",
      "KERYDIN",
      "KESIMPTA",
      "KETALAR",
      "KETAMINE HYDROCHLORIDE",
      "KETOCONAZOLE",
      "KETOPROFEN",
      "KETOROLAC TROMETHAMINE",
      "KETOROLAC TROMETHAMINE AND PHENYLEPHRINE HYDROCHLORIDE",
      "KETOTIFEN FUMARATE",
      "KEVEYIS",
      "KEVZARA",
      "KEYTRUDA",
      "KHAPZORY",
      "KIMIDESS",
      "KIMMTRAK",
      "KIMYRSA",
      "KINERET",
      "KINEVAC",
      "KIONEX",
      "KISQALI",
      "KISQALI FEMARA CO-PACK (COPACKAGED)",
      "KITABIS PAK",
      "KLARON",
      "KLISYRI",
      "KLONOPIN",
      "KLOR-CON",
      "KLOXXADO",
      "KOMBIGLYZE XR",
      "KORLYM",
      "KORSUVA",
      "KOSELUGO",
      "KOVANAZE",
      "KRAZATI",
      "KRINTAFEL",
      "KRYSTEXXA",
      "KURVELO",
      "KUVAN",
      "KYBELLA",
      "KYLEENA",
      "KYPROLIS",
      "KYZATREX",
      "L-GLUTAMINE",
      "LABETALOL HYDROCHLORIDE",
      "LABETALOL HYDROCHLORIDE IN DEXTROSE",
      "LABETALOL HYDROCHLORIDE IN SODIUM CHLORIDE",
      "LACOSAMIDE",
      "LACTATED RINGER'S AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "LACTATED RINGER'S IN PLASTIC CONTAINER",
      "LACTULOSE",
      "LAMICTAL",
      "LAMICTAL CD",
      "LAMICTAL ODT",
      "LAMICTAL XR",
      "LAMISIL",
      "LAMISIL AT",
      "LAMIVUDINE",
      "LAMIVUDINE AND STAVUDINE",
      "LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
      "LAMIVUDINE AND ZIDOVUDINE",
      "LAMIVUDINE, NEVIRAPINE, AND STAVUDINE",
      "LAMIVUDINE, ZIDOVUDINE TABS 150MG/300MG CO-PACKAGED WITH NEVIRAPINE TABS 200MG",
      "Lamivudine, Zidovudine, Nevirapine Tabs 150mg/300mg/200mg",
      "LAMIVUDINE/NEVIRAPINE/ZIDOVUDINE TABLETS",
      "LAMIVUDINE/TENOFOVIR DISOPROXIL FUMARATE FDC TABS",
      "Lamivudine/Zidovudine 150 mg/300 mg Tablets Co-packaged with Nevirapine 200 mg Tablets",
      "LAMIVUDINE",
      " NEVIRAPINE",
      " ZIDOVUDINE",
      "LAMIVUDINE",
      " STAVUDINE",
      "LAMIVUDINE",
      " TENOFOVIR DISOPROXIL FUMARATE",
      "LAMIVUDINE",
      " TENOFOVIR DISOPROXIL FUMARATE",
      " NEVIRAPINE",
      "LAMIVUDINE",
      " ZIDOVUDINE",
      "LAMIVUDINE",
      " ZIDOVUDINE",
      " ABACAVIR",
      "LAMIVUDINE",
      " ZIDOVUDINE",
      " EFAVIRENZ",
      "LAMOTRIGINE",
      "LAMPIT",
      "LAMZEDE",
      "LANORINAL",
      "LANOXIN",
      "LANOXIN PEDIATRIC",
      "LANREOTIDE ACETATE",
      "LANSOPRAZOLE",
      "LANSOPRAZOLE, AMOXICILLIN AND CLARITHROMYCIN (COPACKAGED)",
      "LANTHANUM CARBONATE",
      "LANTUS",
      "LANTUS SOLOSTAR",
      "LAPATINIB DITOSYLATE",
      "LARIN FE 1.5/30",
      "LARIN FE 1/20",
      "LAROTID",
      "LARTRUVO",
      "LARYNG-O-JET KIT",
      "LASIX",
      "LASTACAFT",
      "LATANOPROST",
      "LATISSE",
      "LATUDA",
      "LEFLUNOMIDE",
      "LEMTRADA",
      "LENALIDOMIDE",
      "LENVATINIB",
      "LENVIMA",
      "LEQEMBI",
      "LEQVIO",
      "LERIBANE",
      "LESCOL XL",
      "LESSINA-28",
      "LETAIRIS",
      "LETROZOLE",
      "LETROZOLE",
      "VRIBOCICLIB SUCCINATE",
      "LEUCOVORIN CALCIUM",
      "LEUCOVORIN CALCIUM PRESERVATIVE FREE",
      "LEUKERAN",
      "LEUKINE",
      "LEUPROLIDE ACETATE",
      "LEVALBUTEROL HYDROCHLORIDE",
      "LEVEMIR",
      "LEVEMIR FLEXTOUCH",
      "LEVETIRACETAM",
      "LEVETIRACETAM IN SODIUM CHLORIDE",
      "LEVO-T",
      "LEVOBUNOLOL HYDROCHLORIDE",
      "LEVOCARNITINE",
      "LEVOCARNITINE SF",
      "LEVOCETIRIZINE DIHYDROCHLORIDE",
      "LEVOCETIRIZINE HYDROCHLORIDE",
      "LEVOFLOXACIN",
      "LEVOFLOXACIN IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "LEVOFLOXACIN",
      " DEXTROSE",
      "LEVOLET",
      "LEVOLEUCOVORIN CALCIUM",
      "LEVOMILNACIPRAN",
      "LEVONEST",
      "LEVONORGESTREL",
      "LEVONORGESTREL AND ETHINYL ESTRADIOL",
      "LEVONORGESTREL AND ETHINYL ESTRADIOL AND ETHINYL ESTRADIOL",
      "LEVOPHED",
      "LEVORA 0.15/30-28",
      "LEVORPHANOL TARTRATE",
      "LEVOTHYROXINE SODIUM",
      "LEVOXYL",
      "LEVULAN",
      "LEXAPRO",
      "LEXETTE",
      "LEXISCAN",
      "LEXIVA",
      "LIALDA",
      "LIBERVANT",
      "LIBRAX",
      "LIBRIUM",
      "LIBTAYO",
      "LIDEX",
      "LIDOCAINE",
      "LIDOCAINE AND PRILOCAINE",
      "LIDOCAINE HYDROCHLORIDE",
      "LIDOCAINE HYDROCHLORIDE 0.2% AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "LIDOCAINE HYDROCHLORIDE 0.4% AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "LIDOCAINE HYDROCHLORIDE 0.8% AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "LIDOCAINE HYDROCHLORIDE 5% AND DEXTROSE 7.5%",
      "LIDOCAINE HYDROCHLORIDE AND EPINEPHRINE",
      "LIDOCAINE HYDROCHLORIDE IN PLASTIC CONTAINER",
      "LIDOCAINE HYDROCHLORIDE PRESERVATIVE FREE",
      "LIDOCAINE HYDROCHLORIDE PRESERVATIVE FREE IN PLASTIC CONTAINER",
      "LIDOCAINE HYDROCHLORIDE VISCOUS",
      "LIDOCAINE VISCOUS",
      "LIDODERM",
      "LIFITEGRAST",
      "LIGNOSPAN FORTE",
      "LIGNOSPAN STANDARD",
      "LILETTA",
      "LINACLOTIDE",
      "LINAGLIPTIN",
      "LINAGLIPTIN AND METFORMIN HYDROCHLORIDE",
      "LINAGLIPTIN",
      " METFORMIN HYDROCHLORIDE",
      "LINCOCIN",
      "LINCOMYCIN HYDROCHLORIDE",
      "LINEZOLID",
      "LINEZOLID IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "LINZESS",
      "LIORESAL",
      "LIOTHYRONINE SODIUM",
      "LIPIODOL",
      "LIPITOR",
      "LIPOFEN",
      "LIQREV",
      "LIQUID E-Z-PAQUE",
      "LISDEXAMFETAMINE DIMESYLATE",
      "LISINOPRIL",
      "LISINOPRIL AND HYDROCHLOROTHIAZIDE",
      "LITFULO",
      "LITHIUM CARBONATE",
      "LITHIUM CITRATE",
      "LITHOBID",
      "LITHOSTAT",
      "LIVALO",
      "LIVMARLI",
      "LIVTENCITY",
      "LO LARIN FE",
      "LO LOESTRIN FE",
      "LO SIMPESSE",
      "LO-BLISOVI FE",
      "LO-MALMOREDE",
      "LO-ZUMANDIMINE",
      "LO/OVRAL FE",
      "LOCAMETZ",
      "LOCHOLEST",
      "LOCHOLEST LIGHT",
      "LOCOID",
      "LOCOID LIPOCREAM",
      "LODOSYN",
      "LOGILIA",
      "LOKELMA",
      "LOMAIRA",
      "LOMOTIL",
      "LONSURF",
      "LOPERAMIDE HYDROCHLORIDE",
      "LOPERAMIDE HYDROCHLORIDE AND SIMETHICONE",
      "LOPID",
      "LOPINAVIR AND RITONAVIR",
      "LOPINAVIR",
      " RITONAVIR",
      "LOPRESSOR",
      "LOPRESSOR HCT",
      "LOPROX",
      "LOPURIN",
      "LORATADINE",
      "LORATADINE AND PSEUDOEPHEDRINE SULFATE",
      "LORATADINE REDIDOSE",
      "LORAZEPAM",
      "LORAZEPAM INTENSOL",
      "LORBRENA",
      "LORCASERIN HYDROCHLORIDE",
      "LOREEV XR",
      "LORYNA",
      "LOSARTAN POTASSIUM",
      "LOSARTAN POTASSIUM AND HYDROCHLOROTHIAZIDE",
      "LOSEASONIQUE",
      "LOTEMAX",
      "LOTEMAX SM",
      "LOTENSIN",
      "LOTENSIN HCT",
      "LOTEPREDNOL ETABONATE",
      "LOTREL",
      "LOTRIMIN AF",
      "LOTRIMIN ULTRA",
      "LOTRONEX",
      "LOVASTATIN",
      "LOVAZA",
      "LOVENOX",
      "LOVENOX (PRESERVATIVE FREE)",
      "LOW-OGESTREL-28",
      "LOXAPINE SUCCINATE",
      "LUBIPROSTONE",
      "LUCEMYRA",
      "LUCENTIS",
      "LUMAKRAS",
      "LUMASON",
      "LUMIFY",
      "LUMIGAN",
      "LUMIZYME",
      "LUMOXITI",
      "LUMRYZ",
      "LUNESTA",
      "LUNSUMIO",
      "LUPKYNIS",
      "LUPRON DEPOT",
      "LUPRON DEPOT-PED KIT",
      "LURASIDONE HYDROCHLORIDE",
      "LUTATHERA",
      "LUTRATE DEPOT KIT",
      "LUVOX",
      "LUXIQ",
      "LYBALVI",
      "LYMPHOSEEK KIT",
      "LYNPARZA",
      "LYPQOZET",
      "LYRICA",
      "LYRICA CR",
      "LYSTEDA",
      "LYTGOBI",
      "LYUMJEV",
      "LYVISPAH",
      "M-ZOLE 3 COMBINATION PACK",
      "MACITENTAN",
      "MACROBID",
      "MACRODANTIN",
      "MAGNESIUM SULFATE",
      "MAGNESIUM SULFATE ANHYDROUS",
      " POTASSIUM SULFATE",
      " SODIUM SULFATE",
      "MAGNESIUM SULFATE IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "MAGNESIUM SULFATE IN PLASTIC CONTAINER",
      "MALARONE",
      "MALARONE PEDIATRIC",
      "MALATHION",
      "MALMOREDE",
      "MANGANESE CHLORIDE IN PLASTIC CONTAINER",
      "MANNITOL 10% IN PLASTIC CONTAINER",
      "MANNITOL 15% IN PLASTIC CONTAINER",
      "MANNITOL 20% IN PLASTIC CONTAINER",
      "MANNITOL 25%",
      "MANNITOL 5% IN PLASTIC CONTAINER",
      "MARAVIROC",
      "MARCAINE HYDROCHLORIDE",
      "MARCAINE HYDROCHLORIDE PRESERVATIVE FREE",
      "MARCAINE HYDROCHLORIDE W/ EPINEPHRINE",
      "MARCAINE HYDROCHLORIDE W/ EPINEPHRINE PRESERVATIVE FREE",
      "MARGENZA",
      "MARINOL",
      "MARLISSA",
      "MATULANE",
      "MAVENCLAD",
      "MAVYRET",
      "MAXALT",
      "MAXALT-MLT",
      "MAXIDEX",
      "MAXIPIME",
      "MAXITROL",
      "MAXZIDE",
      "MAXZIDE-25",
      "MAYZENT",
      "MD-GASTROVIEW",
      "MECAMYLAMINE HYDROCHLORIDE",
      "MECLIZINE HYDROCHLORIDE",
      "MECLOFENAMATE SODIUM",
      "MEDICAL AIR, USP",
      "MEDROL",
      "MEDROXYPROGESTERONE ACETATE",
      "MEFENAMIC ACID",
      "MEFLOQUINE HYDROCHLORIDE",
      "MEGACE ES",
      "MEGATOPE",
      "MEGESTROL ACETATE",
      "MEKINIST",
      "MEKTOVI",
      "MELAMISA",
      "MELOXICAM",
      "MELPHALAN",
      "MELPHALAN HYDROCHLORIDE",
      "MEMANTINE HYDROCHLORIDE",
      "MEMANTINE",
      "DONEPEZIL HYDROCHLORIDES",
      "MEN'S ROGAINE",
      "MENEST",
      "MENOPUR",
      "MENOSTAR",
      "MENTAX",
      "MEPERIDINE HYDROCHLORIDE",
      "MEPERIDINE HYDROCHLORIDE PRESERVATIVE FREE",
      "MEPROBAMATE",
      "MEPRON",
      "MEPSEVII",
      "MERCAPTOPURINE",
      "MEROPENEM",
      "MEROPENEM AND SODIUM CHLORIDE IN DUPLEX CONTAINER",
      "MERREM",
      "MERZEE",
      "MESALAMINE",
      "MESNA",
      "MESNEX",
      "MESTINON",
      "METAPROTERENOL SULFATE",
      "METARAMINOL BITARTRATE",
      "METASTRON",
      "METAXALONE",
      "METFORMIN HYDROCHLORIDE",
      "METFORMIN HYDROCHLORIDE AND SITAGLIPTIN PHOSPHATE",
      "METFORMIN HYDROCHLORIDE",
      " SAXAGLIPTIN HYDROCHLORIDE",
      "METHADONE HYDROCHLORIDE",
      "METHADONE HYDROCHLORIDE INTENSOL",
      "METHADOSE",
      "METHAMPHETAMINE HYDROCHLORIDE",
      "METHAZOLAMIDE",
      "METHENAMINE HIPPURATE",
      "METHERGINE",
      "METHIMAZOLE",
      "METHOCARBAMOL",
      "METHOTREXATE PRESERVATIVE FREE",
      "METHOTREXATE SODIUM",
      "METHOTREXATE SODIUM PRESERVATIVE FREE",
      "METHOXSALEN",
      "METHSCOPOLAMINE BROMIDE",
      "METHSUXIMIDE",
      "METHYLDOPA",
      "METHYLERGONOVINE MALEATE",
      "METHYLIN",
      "METHYLIN ER",
      "METHYLNALTREXONE BROMIDE",
      "METHYLPHENIDATE",
      "METHYLPHENIDATE HYDROCHLORIDE",
      "METHYLPREDNISOLONE",
      "METHYLPREDNISOLONE ACETATE",
      "METHYLPREDNISOLONE SODIUM SUCCINATE",
      "METHYLTESTOSTERONE",
      "METOCLOPRAMIDE",
      "METOCLOPRAMIDE HYDROCHLORIDE",
      "METOLAZONE",
      "METOPIRONE",
      "METOPROLOL SUCCINATE",
      "METOPROLOL TARTRATE",
      "METOPROLOL TARTRATE AND HYDROCHLOROTHIAZIDE",
      "METRO I.V. IN PLASTIC CONTAINER",
      "METROCREAM",
      "METROGEL",
      "METROGEL-VAGINAL",
      "METROLOTION",
      "METRONIDAZOLE",
      "METRONIDAZOLE IN PLASTIC CONTAINER",
      "METYROSINE",
      "MEXILETINE HYDROCHLORIDE",
      "MIACALCIN",
      "MIBELAS 24 FE",
      "MICAFUNGIN",
      "MICAFUNGIN SODIUM",
      "MICARDIS",
      "MICARDIS HCT",
      "MICONAZOLE 3",
      "MICONAZOLE 7",
      "MICONAZOLE NITRATE",
      "MICONAZOLE NITRATE COMBINATION PACK",
      "MICORT-HC",
      "MICROZIDE",
      "MIDAMOR",
      "MIDAZOLAM",
      "MIDAZOLAM HYDROCHLORIDE",
      "MIDAZOLAM HYDROCHLORIDE PRESERVATIVE FREE",
      "MIDAZOLAM IN 0.8% SODIUM CHLORIDE",
      "MIDAZOLAM IN 0.9% SODIUM CHLORIDE",
      "MIDODRINE HYDROCHLORIDE",
      "MIDOL LIQUID GELS",
      "MIEBO",
      "MIFEPREX",
      "MIFEPRISTONE",
      "MIGERGOT",
      "MIGLITOL",
      "MIGLUSTAT",
      "MIGRANAL",
      "MILI",
      "MILNACIPRAN HYDROCHLORIDE",
      "MILRINONE LACTATE",
      "MILRINONE LACTATE IN DEXTROSE 5%",
      "MILRINONE LACTATE IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "MILRINONE LACTATE IN PLASTIC CONTAINER",
      "MINIPRESS",
      "MINIVELLE",
      "MINOCIN",
      "MINOCYCLINE",
      "MINOCYCLINE HYDROCHLORIDE",
      "MINOLIRA",
      "MINOXIDIL",
      "MINOXIDIL (FOR MEN)",
      "MINOXIDIL (FOR WOMEN)",
      "MINOXIDIL EXTRA STRENGTH (FOR MEN)",
      "MIOCHOL-E",
      "MIOSTAT",
      "MIRABEGRON",
      "MIRALAX",
      "MIRAPEX ER",
      "MIRCERA",
      "MIRENA",
      "MIRTAZAPINE",
      "MIRVASO",
      "MISOPROSTOL",
      "MITIGARE",
      "MITIGO",
      "MITOMYCIN",
      "MITOSOL",
      "MITOXANTRONE HYDROCHLORIDE",
      "MIVACURIUM CHLORIDE",
      "MOBIC",
      "MODAFINIL",
      "MOEXIPRIL HYDROCHLORIDE",
      "MOEXIPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
      "MOLINDONE HYDROCHLORIDE",
      "MOMETASONE FUROATE",
      "MONISTAT 1 COMBINATION PACK",
      "MONISTAT 3",
      "MONISTAT 3 COMBINATION PACK",
      "MONISTAT 3 COMBINATION PACK (PREFILLED)",
      "MONISTAT 7",
      "MONISTAT 7 COMBINATION PACK",
      "MONJUVI",
      "MONO-LINYAH",
      "MONOBASIC SODIUM PHOSPHATE AND DIBASIC SODIUM PHOSPHATE",
      "MONODOX",
      "MONOFERRIC",
      "MONOKET",
      "MONTELUKAST SODIUM",
      "MONUROL",
      "MORPHINE SULFATE",
      "MOTEGRITY",
      "MOTOFEN",
      "MOTPOLY XR",
      "MOTRIN IB",
      "MOUNJARO",
      "MOVANTIK",
      "MOVIPREP",
      "MOXIDECTIN",
      "MOXIFLOXACIN HYDROCHLORIDE",
      "MOXIFLOXACIN HYDROCHLORIDE IN SODIUM CHLORIDE 0.8% IN PLASTIC CONTAINER",
      "MOZOBIL",
      "MPI INDIUM DTPA IN 111",
      "MS CONTIN",
      "MUCINEX",
      "MUCINEX DM",
      "MULPLETA",
      "MULTAQ",
      "MULTIHANCE",
      "MULTIHANCE MULTIPACK",
      "MULTIPLE ELECTROLYTES INJECTION TYPE 1 USP PH 5.5",
      "MULTIPLE ELECTROLYTES INJECTION TYPE 1 USP PH 7.4",
      "MULTRYS",
      "MUPIROCIN",
      "MUSE",
      "MVASI",
      "MYALEPT",
      "MYAMBUTOL",
      "MYCAMINE",
      "MYCAPSSA",
      "MYCELEX",
      "MYCOBUTIN",
      "MYCOPHENOLATE MOFETIL",
      "MYCOPHENOLATE MOFETIL HYDROCHLORIDE",
      "MYCOPHENOLIC SODIUM",
      "MYDAYIS",
      "MYDCOMBI",
      "MYDRIACYL",
      "MYFEMBREE",
      "MYFORTIC",
      "MYKACET",
      "MYLERAN",
      "MYLOTARG",
      "MYOBLOC",
      "MYORISAN",
      "MYOVIEW",
      "MYOVIEW 30ML",
      "MYOZYME",
      "MYRBETRIQ",
      "MYRBETRIQ GRANULES",
      "MYSOLINE",
      "MYZILRA",
      "NABUMETONE",
      "NADOLOL",
      "NAFCILLIN SODIUM",
      "NAFTIFINE HYDROCHLORIDE",
      "NAFTIN",
      "NAGLAZYME",
      "NALBUPHINE HYDROCHLORIDE",
      "NALFON",
      "NALLPEN IN PLASTIC CONTAINER",
      "NALMEFENE HYDROCHLORIDE",
      "NALOXEGOL",
      "NALOXONE",
      "NALOXONE HYDROCHLORIDE",
      "NALOXONE HYDROCHLORIDE AND PENTAZOCINE HYDROCHLORIDE",
      "NALTREXONE",
      "NALTREXONE HYDROCHLORIDE",
      "NALTREXONE HYDROCHLORIDE",
      " BUPROPION HYDROCHLORIDE",
      "NAMENDA",
      "NAMENDA XR",
      "NAMZARIC",
      "NAPHAZOLINE HYDROCHLORIDE AND PHENIRAMINE MALEATE",
      "NAPHCON-A",
      "NAPRELAN",
      "NAPROSYN",
      "NAPROXEN",
      "NAPROXEN AND ESOMEPRAZOLE MAGNESIUM",
      "NAPROXEN SODIUM",
      "NAPROXEN SODIUM AND DIPHENHYDRAMINE HYDROCHLORIDE",
      "NAPROXEN SODIUM AND PSEUDOEPHEDRINE HYDROCHLORIDE",
      "NARATRIPTAN",
      "NARCAN",
      "NARDIL",
      "NAROPIN",
      "NASACORT ALLERGY 24 HOUR",
      "NASCOBAL",
      "NASONEX 24HR ALLERGY",
      "NATACYN",
      "NATAZIA",
      "NATEGLINIDE",
      "NATESTO",
      "NATPARA",
      "NATROBA",
      "NAYZILAM",
      "NEBIVOLOL HYDROCHLORIDE",
      "NEBUPENT",
      "NEFAZODONE HYDROCHLORIDE",
      "NELARABINE",
      "NEMBUTAL SODIUM",
      "NEO-SYNALAR",
      "NEOMYCIN AND POLYMYXIN B SULFATE",
      "NEOMYCIN AND POLYMYXIN B SULFATES AND BACITRACIN ZINC",
      "NEOMYCIN AND POLYMYXIN B SULFATES AND DEXAMETHASONE",
      "NEOMYCIN AND POLYMYXIN B SULFATES AND GRAMICIDIN",
      "NEOMYCIN AND POLYMYXIN B SULFATES AND HYDROCORTISONE",
      "NEOMYCIN AND POLYMYXIN B SULFATES, BACITRACIN ZINC AND HYDROCORTISONE",
      "NEOMYCIN SULFATE",
      "NEOPROFEN",
      "NEORAL",
      "NEOSPORIN",
      "NEOSPORIN G.U. IRRIGANT",
      "NEOSTIGMINE METHYLSULFATE",
      "NEOSTIGMINE METHYSULFATE",
      "NEPHROSCAN",
      "NERATINIB MALEATE",
      "NERLYNX",
      "NESACAINE",
      "NESACAINE-MPF",
      "NESINA",
      "NETSPOT",
      "NEULASTA",
      "NEUPOGEN",
      "NEUPRO",
      "NEURACEQ",
      "NEUROLITE",
      "NEURONTIN",
      "NEVANAC",
      "NEVIRAPINE",
      "NEVIRAPINE TABLETS FOR ORAL SUSPENSION",
      "NEXAVAR",
      "NEXESTA FE",
      "NEXICLON XR",
      "NEXIUM",
      "NEXIUM 24HR",
      "NEXIUM IV",
      "NEXOBRID",
      "NEXPLANON",
      "NEXTERONE",
      "NEXVIAZYME",
      "NGENLA",
      "NIACIN",
      "NIACOR",
      "NICARDIPINE HYDROCHLORIDE",
      "NICARDIPINE HYDROCHLORIDE IN 0.9% SODIUM CHLORIDE",
      "NICODERM CQ",
      "NICORETTE",
      "NICORETTE (MINT)",
      "NICOTINE",
      "NICOTINE POLACRILEX",
      "NICOTROL",
      "NIFEDIPINE",
      "NIKKI",
      "NILANDRON",
      "NILOTINIB HYDROCHLORIDE",
      "NILUTAMIDE",
      "NIMBEX",
      "NIMBEX PRESERVATIVE FREE",
      "NIMODIPINE",
      "NINLARO",
      "NINTEDANIB",
      "NIPENT",
      "NIPRIDE RTU IN SODIUM CHLORIDE 0.9%",
      "NISOLDIPINE",
      "NITAZOXANIDE",
      "NITHIODOTE",
      "NITISINONE",
      "NITRO-DUR",
      "NITROFURANTOIN",
      "NITROFURANTOIN (MONOHYDRATE/MACROCRYSTALS)",
      "NITROGEN, NF",
      "NITROGLYCERIN",
      "NITROGLYCERIN IN DEXTROSE 5%",
      "NITROLINGUAL PUMPSPRAY",
      "NITROMIST",
      "NITROSTAT",
      "NITROUS OXIDE, USP",
      "NITYR",
      "NIVESTYM",
      "NIX",
      "NIZATIDINE",
      "NIZORAL ANTI-DANDRUFF",
      "NOCDURNA",
      "NOR-QD",
      "NORDITROPIN FLEXPRO",
      "NOREPINEPHRINE BITARTRATE",
      "NOREPINEPHRINE BITARTRATE IN 0.9% SODIUM CHLORIDE",
      "NOREPINEPHRINE BITARTRATE IN 5% DEXTROSE",
      "NORETHINDRONE",
      "NORETHINDRONE ACETATE",
      "NORETHINDRONE ACETATE AND ETHINYL ESTRADIOL",
      "NORETHINDRONE ACETATE AND ETHINYL ESTRADIOL AND FERROUS FUMARATE",
      "NORETHINDRONE ACETATE",
      " ETHINYL ESTRADIOL",
      " ETHINYL ESTRADIOL",
      " FERROUS FUMARATE",
      "NORETHINDRONE AND ETHINYL ESTRADIOL",
      "NORETHINDRONE AND ETHINYL ESTRADIOL (10/11)",
      "NORETHINDRONE AND ETHINYL ESTRADIOL AND FERROUS FUMARATE",
      "NORGESTIMATE AND ETHINYL ESTRADIOL",
      "NORGESTIMATE",
      " ETHINYL ESTRADIOL",
      "NORITATE",
      "NORLIQVA",
      "NORMOCARB HF 25",
      "NORMOCARB HF 35",
      "NORMOSOL-M AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "NORMOSOL-R AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "NORMOSOL-R IN PLASTIC CONTAINER",
      "NORPACE",
      "NORPACE CR",
      "NORPRAMIN",
      "NORTHERA",
      "NORTREL 0.5/35-28",
      "NORTREL 1/35-21",
      "NORTREL 1/35-28",
      "NORTREL 7/7/7",
      "NORTRIPTYLINE HYDROCHLORIDE",
      "NORVASC",
      "NORVIR",
      "NOURIANZ",
      "NOVOLIN 70/30",
      "NOVOLIN N",
      "NOVOLIN R",
      "NOVOLOG",
      "NOVOLOG FLEXPEN",
      "NOVOLOG MIX 70/30",
      "NOVOLOG MIX 70/30 FLEXPEN",
      "NOVOLOG PENFILL",
      "NOXAFIL",
      "NOXAFIL POWDERMIX KIT",
      "NOXIVENT",
      "NPLATE",
      "NUBEQA",
      "NUCALA",
      "NUCYNTA",
      "NUCYNTA ER",
      "NUEDEXTA",
      "NULIBRY",
      "NULOJIX",
      "NULYTELY",
      "NULYTELY-FLAVORED",
      "NUMBRINO",
      "NUPLAZID",
      "NUTRILIPID 10%",
      "NUTRILIPID 20%",
      "NUTROPIN",
      "NUTROPIN AQ NUSPIN",
      "NUVARING",
      "NUVESSA",
      "NUVIGIL",
      "NUZYRA",
      "NYLIA 1/35",
      "NYLIA 7/7/7",
      "NYMALIZE",
      "NYSTATIN",
      "NYSTATIN AND TRIAMCINOLONE ACETONIDE",
      "NYSTOP",
      "NYVEPRIA",
      "OBETICHOLIC ACID",
      "OCALIVA",
      "OCREVUS",
      "OCTREOSCAN",
      "OCTREOTIDE ACETATE",
      "OCTREOTIDE ACETATE (PRESERVATIVE FREE)",
      "OCUFLOX",
      "ODEFSEY",
      "ODOMZO",
      "OFEV",
      "OFLOXACIN",
      "OGEN 5",
      "OGIVRI",
      "OLANZAPINE",
      "OLANZAPINE AND FLUOXETINE HYDROCHLORIDE",
      "OLINVYK",
      "OLMESARTAN MEDOXOMIL",
      "OLMESARTAN MEDOXOMIL AND HYDROCHLOROTHIAZIDE",
      "OLMESARTAN MEDOXOMIL, AMLODIPINE AND HYDROCHLOROTHIAZIDE",
      "OLOPATADINE HYDROCHLORIDE",
      "OLPRUVA",
      "OLUMIANT",
      "OLUX",
      "OLUX E",
      "OMACOR",
      "OMEGA-3-ACID ETHYL ESTERS",
      "OMEGAVEN",
      "OMEPRAZOLE",
      "OMEPRAZOLE AND SODIUM BICARBONATE",
      "OMEPRAZOLE MAGNESIUM",
      "OMIDRIA",
      "OMNARIS",
      "OMNIPAQUE 300",
      "OMNIPAQUE 350",
      "OMNIPRED",
      "OMNISCAN",
      "OMNITROPE",
      "ONCASPAR",
      "ONDANSETRON",
      "ONDANSETRON HYDROCHLORIDE",
      "ONDANSETRON HYDROCHLORIDE PRESERVATIVE FREE",
      "ONEXTON",
      "ONFI",
      "ONGENTYS",
      "ONGLYZA",
      "ONIVYDE",
      "ONPATTRO",
      "ONSURA",
      "ONTAK",
      "ONTRUZANT",
      "ONUREG",
      "ONZETRA XSAIL",
      "OPCON-A",
      "OPDIVO",
      "OPDUALAG",
      "OPSUMIT",
      "OPTIRAY 300",
      "OPTIRAY 320",
      "OPTIRAY 350",
      "OPTISON",
      "OPVEE",
      "OPZELURA",
      "ORABLOC",
      "ORACEA",
      "ORAPRED ODT",
      "ORAQIX",
      "ORAVERSE",
      "ORAVIG",
      "ORBACTIV",
      "ORENCIA",
      "ORENITRAM",
      "ORFADIN",
      "ORGOVYX",
      "ORIAHNN (COPACKAGED)",
      "ORILISSA",
      "ORKAMBI",
      "ORLADEYO",
      "ORPHENADRINE CITRATE",
      "ORPHENGESIC",
      "ORPHENGESIC FORTE",
      "ORSERDU",
      "ORTHO TRI-CYCLEN 21",
      "ORTHO TRI-CYCLEN 28",
      "ORTIKOS",
      "ORVATEN",
      "OSELTAMIVIR PHOSPHATE",
      "OSENI",
      "OSIMERTINIB MESYLATE",
      "OSMITROL 10% IN WATER",
      "OSMITROL 10% IN WATER IN PLASTIC CONTAINER",
      "OSMITROL 15% IN WATER",
      "OSMITROL 15% IN WATER IN PLASTIC CONTAINER",
      "OSMITROL 20% IN WATER",
      "OSMITROL 20% IN WATER IN PLASTIC CONTAINER",
      "OSMITROL 5% IN WATER",
      "OSMITROL 5% IN WATER IN PLASTIC CONTAINER",
      "OSMOLEX ER",
      "OSPEMIFENE",
      "OSPHENA",
      "OTEZLA",
      "OTICAIR",
      "OTOVEL",
      "OTREXUP",
      "OVIDREL",
      "OXACILLIN SODIUM",
      "OXALIPLATIN",
      "OXAPROZIN",
      "OXAYDO",
      "OXAZEPAM",
      "OXBRYTA",
      "OXCARBAZEPINE",
      "OXERVATE",
      "OXICONAZOLE NITRATE",
      "OXISTAT",
      "OXLUMO",
      "OXSORALEN-ULTRA",
      "OXTELLAR XR",
      "OXYBUTYNIN CHLORIDE",
      "OXYCET",
      "OXYCODONE AND ACETAMINOPHEN",
      "OXYCODONE AND ASPIRIN",
      "OXYCODONE HYDROCHLORIDE",
      "OXYCONTIN",
      "OXYGEN, USP",
      "OXYMETAZOLINE",
      "OXYMORPHONE HYDROCHLORIDE",
      "OXYTOCIN",
      "OXYTROL",
      "OXYTROL FOR WOMEN",
      "OZEMPIC",
      "OZOBAX",
      "OZURDEX",
      "PACERONE",
      "PACLITAXEL",
      "PADCEV",
      "PALBOCICLIB",
      "PALIPERIDONE",
      "PALIPERIDONE PALMITATE",
      "PALONOSETRON HYDROCHLORIDE",
      "PALYNZIQ",
      "PAMELOR",
      "PAMIDRONATE DISODIUM",
      "PANCREAZE",
      "PANCURONIUM BROMIDE",
      "PANDEL",
      "PANRETIN",
      "PANTOPRAZOLE SODIUM",
      "PARAGARD T 380A",
      "PARICALCITOL",
      "PARLODEL",
      "PARNATE",
      "PAROMOMYCIN SULFATE",
      "PAROXETINE",
      "PAROXETINE HYDROCHLORIDE",
      "PAROXETINE MESYLATE",
      "PARSABIV",
      "PASER",
      "PATADAY ONCE DAILY RELIEF",
      "PATADAY TWICE DAILY RELIEF",
      "PAXIL",
      "PAXIL CR",
      "PAXLOVID (COPACKAGED)",
      "PEDIAPRED",
      "PEDMARK",
      "PEG 3350 AND ELECTROLYTES",
      "PEG-3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE",
      "PEG-3350, SODIUM SULFATE, SODIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ASCORBATE AND ASCORBIC ACID",
      "PEGASYS",
      "PEGINTRON",
      "PEMAZYRE",
      "PEMETREXED",
      "PEMETREXED DISODIUM",
      "PEMETREXED DITROMETHAMINE",
      "PEMETREXED FOR INJECTION",
      "PEMFEXY",
      "PENCICLOVIR",
      "PENICILLAMINE",
      "PENICILLIN G POTASSIUM",
      "PENICILLIN G POTASSIUM IN PLASTIC CONTAINER",
      "PENICILLIN G PROCAINE",
      "PENICILLIN G SODIUM",
      "PENICILLIN V POTASSIUM",
      "PENICILLIN-VK",
      "PENNSAID",
      "PENTAM",
      "PENTAMIDINE ISETHIONATE",
      "PENTASA",
      "PENTOBARBITAL SODIUM",
      "PENTOLAIR",
      "PENTOSTATIN",
      "PENTOXIFYLLINE",
      "PEPCID AC",
      "PEPCID COMPLETE",
      "PERAMPANEL",
      "PERCOCET",
      "PERCODAN",
      "PERFOROMIST",
      "PERIDEX",
      "PERIKABIVEN IN PLASTIC CONTAINER",
      "PERINDOPRIL ERBUMINE",
      "PERIOGARD",
      "PERJETA",
      "PERMETHRIN",
      "PERPHENAZINE",
      "PERPHENAZINE AND AMITRIPTYLINE HYDROCHLORIDE",
      "PERSANTINE",
      "PERSERIS KIT",
      "PERTZYE",
      "PFIZERPEN",
      "PHEBURANE",
      "PHENDIMETRAZINE TARTRATE",
      "PHENELZINE SULFATE",
      "PHENOXYBENZAMINE HYDROCHLORIDE",
      "PHENTERMINE HYDROCHLORIDE",
      "PHENTOLAMINE MESYLATE",
      "PHENYLEPHRINE HYDROCHLORIDE",
      "PHENYLEPHRINE HYDROCHLORIDE AND PROMETHAZINE HYDROCHLORIDE",
      "PHENYTEK",
      "PHENYTOIN",
      "PHENYTOIN SODIUM",
      "PHESGO",
      "PHEXXI",
      "PHILITH",
      "PHOSLO GELCAPS",
      "PHOSPHOLINE IODIDE",
      "PHOTOFRIN",
      "PHOTREXA",
      "PHOTREXA VISCOUS IN DEXTRAN 20%",
      "PHOXILLUM B22K 4/0 IN PLASTIC CONTAINER",
      "PHOXILLUM BK 4/2.5 IN PLASTIC CONTAINER",
      "PHYSIOLYTE IN PLASTIC CONTAINER",
      "PHYSIOSOL IN PLASTIC CONTAINER",
      "PHYTONADIONE",
      "PIFELTRO",
      "PILOCARPINE HYDROCHLORIDE",
      "PIMAVANSERIN",
      "PIMECROLIMUS",
      "PIMOZIDE",
      "PIMTREA",
      "PINDOLOL",
      "PIOGLITAZONE",
      "PIOGLITAZONE HYDROCHLORIDE",
      "PIOGLITAZONE HYDROCHLORIDE AND METFORMIN HYDROCHLORIDE",
      "PIPERACILLIN",
      "PIPERACILLIN AND TAZOBACTAM",
      "PIQRAY",
      "PIRFENIDONE",
      "PIROXICAM",
      "PITAVASTATIN CALCIUM",
      "PITOCIN",
      "PIZENSY",
      "PLAN B ONE-STEP",
      "PLAQUENIL",
      "PLASMA-LYTE 148 IN WATER IN PLASTIC CONTAINER",
      "PLASMA-LYTE A IN PLASTIC CONTAINER",
      "PLAVIX",
      "PLEGISOL IN PLASTIC CONTAINER",
      "PLEGRIDY",
      "PLENVU",
      "PLERIXAFOR",
      "PLIAGLIS",
      "PLUVICTO",
      "PODOFILOX",
      "POLIVY",
      "POLMON",
      "POLOCAINE",
      "POLOCAINE-MPF",
      "POLYETHYLENE GLYCOL 3350",
      "POLYETHYLENE GLYCOL 3350 AND ELECTROLYTES",
      "POLYETHYLENE GLYCOL 3350",
      " SODIUM CHLORIDE",
      " SODIUM BICARBONATE",
      " POTASSIUM CHLORIDE",
      " BISACODYL",
      "POLYMYXIN B SULFATE",
      "POMALIDOMIDE",
      "POMALYST",
      "PONATINIB HYDROCHLORIDE",
      "PONSTEL",
      "PONVORY",
      "PORCINE SECRETIN",
      "PORTIA-28",
      "PORTRAZZA",
      "POSACONAZOLE",
      "POSIMIR",
      "POSLUMA",
      "POTASSIUM ACETATE",
      "POTASSIUM CHLORIDE",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 3.3% AND SODIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 3.3% AND SODIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.149% IN SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 3.3% AND SODIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.15% IN SODIUM CHLORIDE 0.45%",
      "POTASSIUM CHLORIDE 0.15% IN SODIUM CHLORIDE 0.9%",
      "POTASSIUM CHLORIDE 0.15% IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 3.3% AND SODIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% AND SODIUM CHLORIDE 0.9%",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 10% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 3.3% AND SODIUM CHLORIDE 0.3% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.11% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.2% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.33% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 0.3% IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 10MEQ",
      "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.225% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45%",
      "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 10MEQ IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 15MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 20MEQ",
      "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.225% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45%",
      "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9%",
      "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 20MEQ IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 20MEQ IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 30MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 30MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45%",
      "POTASSIUM CHLORIDE 30MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 30MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 30MEQ IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 40MEQ",
      "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45%",
      "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9%",
      "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 40MEQ IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 40MEQ IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 5MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 5MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE 5MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "POTASSIUM CHLORIDE IN PLASTIC CONTAINER",
      "POTASSIUM CITRATE",
      "POTASSIUM IODIDE",
      "POTASSIUM PHOSPHATES",
      "POTELIGEO",
      "POVIDONE IODINE",
      "PRADAXA",
      "PRALATREXATE",
      "PRALUENT",
      "PRAMIPEXOLE DIHYDROCHLORIDE",
      "PRAMOSONE",
      "PRASUGREL",
      "PRAVASTATIN SODIUM",
      "PRAXBIND",
      "PRAZIQUANTEL",
      "PRAZOSIN HYDROCHLORIDE",
      "PRE-OP",
      "PRE-OP II",
      "PRE-PEN",
      "PRECEDEX",
      "PRED FORTE",
      "PRED MILD",
      "PREDNICARBATE",
      "PREDNISOLONE",
      "PREDNISOLONE SODIUM PHOSPHATE",
      "PREDNISONE",
      "PREDNISONE INTENSOL",
      "PREGABALIN",
      "PREGNYL",
      "PRELONE",
      "PREMARIN",
      "PREMASOL 10% IN PLASTIC CONTAINER",
      "PREMASOL 6% IN PLASTIC CONTAINER",
      "PREMPHASE 14/14",
      "PREMPRO",
      "PREMPRO/PREMPHASE",
      "PREPIDIL",
      "PRESTALIA",
      "PRETOMANID",
      "PREVACID",
      "PREVACID 24 HR",
      "PREVALITE",
      "PREVANTICS MAXI SWABSTICK",
      "PREVANTICS SWAB",
      "PREVANTICS SWABSTICK",
      "PREVDUO",
      "PREVIFEM",
      "PREVYMIS",
      "PREZCOBIX",
      "PREZISTA",
      "PRIALT",
      "PRIFTIN",
      "PRILOCAINE HYDROCHLORIDE",
      "PRILOCAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
      "PRILOSEC",
      "PRILOSEC OTC",
      "PRIMAQUINE",
      "PRIMAQUINE PHOSPHATE",
      "PRIMATENE MIST",
      "PRIMAXIN",
      "PRIMIDONE",
      "PRISMASOL B22GK 4/0 IN PLASTIC CONTAINER",
      "PRISMASOL BGK 0/2.5 IN PLASTIC CONTAINER",
      "PRISMASOL BGK 2/0 IN PLASTIC CONTAINER",
      "PRISMASOL BGK 2/3.5 IN PLASTIC CONTAINER",
      "PRISMASOL BGK 4/0/1.2 IN PLASTIC CONTAINER",
      "PRISMASOL BGK 4/2.5 IN PLASTIC CONTAINER",
      "PRISMASOL BK 0/0/1.2 IN PLASTIC CONTAINER",
      "PRISTIQ",
      "PROAIR DIGIHALER",
      "PROAIR HFA",
      "PROAIR RESPICLICK",
      "PROBALAN",
      "PROBENECID",
      "PROBENECID AND COLCHICINE",
      "PROCAINAMIDE HYDROCHLORIDE",
      "PROCARDIA",
      "PROCARDIA XL",
      "PROCHLORPERAZINE",
      "PROCHLORPERAZINE EDISYLATE",
      "PROCHLORPERAZINE MALEATE",
      "PROCOMP",
      "PROCTOFOAM HC",
      "PROCYSBI",
      "PROGESTERONE",
      "PROGLYCEM",
      "PROGRAF",
      "PROHANCE",
      "PROHANCE MULTIPACK",
      "PROLENSA",
      "PROLEUKIN",
      "PROLIA",
      "PROMACTA",
      "PROMACTA KIT",
      "PROMETH HYDROCHLORIDE,PHENYLEPHRINE HYDROCHLORIDE W/CODEINE PHOSPHATE",
      "PROMETHAZINE DM",
      "PROMETHAZINE HYDROCHLORIDE",
      "PROMETHAZINE HYDROCHLORIDE AND CODEINE PHOSPHATE",
      "PROMETHAZINE HYDROCHLORIDE AND DEXTROMETHORPHAN HYDROBROMIDE",
      "PROMETHAZINE HYDROCHLORIDE AND PHENYLEPHRINE HYDROCHLORIDE",
      "PROMETHAZINE HYDROCHLORIDE, PHENYLEPHRINE HYDROCHLORIDE W/CODEINE PHOSPHATE",
      "PROMETHAZINE HYDROCHLORIDE,PHENYLEPHRINE HYDROCHLORIDE W/CODEINE PHOSPHATE",
      "PROMETHAZINE HYDROCHLORIDE",
      " CODEINE PHOSPHATE",
      "PROMETHAZINE HYDROCHLORIDE",
      " DEXTROMETHORPHAN HYDROBROMIDE",
      "PROMETHAZINE PLAIN",
      "PROMETHAZINE W/ DEXTROMETHORPHAN",
      "PROMETHAZINE WITH CODEINE",
      "PROMETHEGAN",
      "PROMETRIUM",
      "PROPAFENONE HYDROCHLORIDE",
      "PROPARACAINE HYDROCHLORIDE",
      "PROPECIA",
      "PROPOFOL",
      "PROPRANOLOL HYDROCHLORIDE",
      "PROPYLTHIOURACIL",
      "PROSCAR",
      "PROSOL 20% SULFITE FREE IN PLASTIC CONTAINER",
      "PROSTASCINT",
      "PROSTIN VR PEDIATRIC",
      "PROTONIX",
      "PROTONIX IV",
      "PROTOPAM CHLORIDE",
      "PROTRIPTYLINE HYDROCHLORIDE",
      "PROVAYBLUE",
      "PROVENTIL-HFA",
      "PROVERA",
      "PROVIGIL",
      "PROVOCHOLINE",
      "PROZAC",
      "PSEUDOEPHEDRINE HYDROCHLORIDE",
      "PULMICORT FLEXHALER",
      "PULMICORT RESPULES",
      "PULMOTECH MAA",
      "PULMOZYME",
      "PUR-WASH",
      "PURIFIED CORTROPHIN GEL",
      "PURINETHOL",
      "PURIXAN",
      "PYLARIFY",
      "PYRAZINAMIDE",
      "PYRIDOSTIGMINE BROMIDE",
      "PYRIDOXINE HYDROCHLORIDE",
      "PYRIMETHAMINE",
      "PYRUKYND",
      "PYTEST",
      "PYTEST KIT",
      "QALSODY",
      "QBRELIS",
      "QBREXZA",
      "QDOLO",
      "QELBREE",
      "QINLOCK",
      "QNASL",
      "QOLIANA",
      "QSYMIA",
      "QTERN",
      "QUALAQUIN",
      "QUARTETTE",
      "QUASENSE",
      "QUDEXY XR",
      "QUELICIN",
      "QUETIAPINE FUMARATE",
      "QUILLICHEW ER",
      "QUILLIVANT XR",
      "QUINAPRIL HYDROCHLORIDE",
      "QUINAPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
      "QUINIDINE GLUCONATE",
      "QUINIDINE SULFATE",
      "QUININE SULFATE",
      "QULIPTA",
      "QUTENZA",
      "QUVIVIQ",
      "QUZYTTIR",
      "QVAR REDIHALER",
      "QWO",
      "R-GENE 10",
      "RABEPRAZOLE SODIUM",
      "RADICAVA",
      "RADICAVA ORS",
      "RADIOGARDASE (PRUSSIAN BLUE)",
      "RADIOGENIX SYSTEM",
      "RALOXIFENE HYDROCHLORIDE",
      "RALTEGRAVIR",
      "RAMELTEON",
      "RAMIPRIL",
      "RANITIDINE",
      "RANITIDINE HYDROCHLORIDE",
      "RANOLAZINE",
      "RAPAFLO",
      "RAPAMUNE",
      "RAPIVAB",
      "RASAGILINE MESYLATE",
      "RAVICTI",
      "RAXIBACUMAB",
      "RAYALDEE",
      "RAYOS",
      "READI-CAT 2",
      "READI-CAT 2 SMOOTHIE",
      "READYPREP CHG",
      "REBIF",
      "REBLOZYL",
      "RECARBRIO",
      "RECLAST",
      "RECTIV",
      "REGADENOSON",
      "REGLAN",
      "REGONOL",
      "REGRANEX",
      "RELENZA",
      "RELEUKO",
      "RELEXXII",
      "RELISTOR",
      "RELPAX",
      "RELYVRIO",
      "REMERON",
      "REMERON SOLTAB",
      "REMICADE",
      "REMIFENTANIL HYDROCHLORIDE",
      "REMODULIN",
      "RENACIDIN",
      "RENAGEL",
      "RENFLEXIS",
      "RENOVA",
      "RENVELA",
      "REOPRO",
      "REPAGLINIDE",
      "REPATHA",
      "RESTASIS",
      "RESTASIS MULTIDOSE",
      "RESTORIL",
      "RETACRIT",
      "RETAVASE",
      "RETEVMO",
      "RETIN-A",
      "RETIN-A MICRO",
      "RETIN-A-MICRO",
      "RETISERT",
      "RETROVIR",
      "REVATIO",
      "REVCOVI",
      "REVLIMID",
      "REVONTO",
      "REXTOVY",
      "REXULTI",
      "REYATAZ",
      "REYVOW",
      "REZIPRES",
      "REZLIDHIA",
      "REZUROCK",
      "REZVOGLAR",
      "REZZAYO",
      "RHINOCORT",
      "RHINOCORT ALLERGY",
      "RHOFADE",
      "RHOPRESSA",
      "RIABNI",
      "RIBAVIRIN",
      "RIDAURA",
      "RIFABUTIN",
      "RIFADIN",
      "RIFAMPIN",
      "RIFAXIMIN",
      "RILPIVIRINE",
      "RILUTEK",
      "RILUZOLE",
      "RIMACTANE",
      "RIMANTADINE HYDROCHLORIDE",
      "RINGER'S IN PLASTIC CONTAINER",
      "RINVOQ",
      "RIOCIGUAT",
      "RISEDRONATE SODIUM",
      "RISPERDAL",
      "RISPERDAL CONSTA",
      "RISPERIDONE",
      "RITALIN",
      "RITALIN LA",
      "RITONAVIR",
      "RITUXAN",
      "RITUXAN HYCELA",
      "RIVAROXABAN",
      "RIVASTIGMINE",
      "RIVASTIGMINE TARTRATE",
      "RIVIVE",
      "RIZAFILM",
      "RIZATRIPTAN BENZOATE",
      "ROBAXIN",
      "ROBINUL",
      "ROBINUL FORTE",
      "ROCALTROL",
      "ROCKLATAN",
      "ROCURONIUM BROMIDE",
      "ROFLUMILAST",
      "ROGAINE (FOR MEN)",
      "ROGAINE (FOR WOMEN)",
      "ROGAINE EXTRA STRENGTH (FOR MEN)",
      "ROLVEDON",
      "ROMIDEPSIN",
      "ROPINIROLE HYDROCHLORIDE",
      "ROPIVACAINE HYDROCHLORIDE",
      "ROSIGLITAZONE",
      "ROSIGLITAZONE MALEATE",
      "ROSUVASTATIN CALCIUM",
      "ROSUVASTATIN ZINC",
      "ROWASA",
      "ROXICODONE",
      "ROXYBOND",
      "ROZEREM",
      "ROZLYTREK",
      "RUBRACA",
      "RUBY-FILL",
      "RUFINAMIDE",
      "RUKOBIA",
      "RUXIENCE",
      "RYALTRIS",
      "RYANODEX",
      "RYBELSUS",
      "RYBREVANT",
      "RYDAPT",
      "RYKINDO",
      "RYLAZE",
      "RYSTIGGO",
      "RYTARY",
      "RYTHMOL SR",
      "SABRIL",
      "SAFINAMIDE",
      "SAFYRAL",
      "SAIZEN",
      "SALAGEN",
      "SALONPAS",
      "SAMSCA",
      "SANCUSO",
      "SANDIMMUNE",
      "SANDOSTATIN",
      "SANDOSTATIN LAR",
      "SANTYL",
      "SAPHNELO",
      "SAPHRIS",
      "SAPROPTERIN DIHYDROCHLORIDE",
      "SARCLISA",
      "SAVAYSA",
      "SAVELLA",
      "SAXAGLIPTIN",
      "SAXAGLIPTIN AND METFORMIN HYDROCHLORIDE",
      "SAXAGLIPTIN",
      "METFORMIN HYDROCHLORIDE",
      "SAXENDA",
      "SCANDONEST L",
      "SCANDONEST PLAIN",
      "SCEMBLIX",
      "SCENESSE",
      "SCLEROSOL",
      "SCOPOLAMINE",
      "SEASONALE",
      "SEASONIQUE",
      "SECUADO",
      "SEGLENTIS",
      "SEGLUROMET",
      "SEIZALAM",
      "SELEGILINE HYDROCHLORIDE",
      "SELENIOUS ACID",
      "SELENIUM SULFIDE",
      "SELEXIPAG",
      "SELZENTRY",
      "SEMGLEE",
      "SENSIPAR",
      "SENSORCAINE",
      "SEPTOCAINE",
      "SEPTRA",
      "SEPTRA DS",
      "SEREVENT",
      "SERNIVO",
      "SEROMYCIN",
      "SEROQUEL",
      "SEROQUEL XR",
      "SERTRALINE HYDROCHLORIDE",
      "SETLAKIN",
      "SEVELAMER CARBONATE",
      "SEVELAMER HYDROCHLORIDE",
      "SEVOFLURANE",
      "SEYSARA",
      "SEZABY",
      "SFROWASA",
      "SIGNIFOR",
      "SIGNIFOR LAR KIT",
      "SIKLOS",
      "SILDENAFIL CITRATE",
      "SILENOR",
      "SILIQ",
      "SILODOSIN",
      "SILVADENE",
      "SIMBRINZA",
      "SIMLIYA",
      "SIMPESSE",
      "SIMPONI",
      "SIMPONI ARIA",
      "SIMULECT",
      "SIMVASTATIN",
      "SINCALIDE",
      "SINE-AID IB",
      "SINEMET",
      "SINGULAIR",
      "SIROLIMUS",
      "SIRTURO",
      "SITAGLIPTIN",
      "SITAGLIPTIN AND METFORMIN HYDROCHLORIDE",
      "SITAGLIPTIN PHOSPHATE",
      "SITAGLIPTIN PHOSPHATE",
      " METFORMIN HYDROCHLORIDE",
      "SITAGLIPTIN",
      " METFORMIN HYDROCHLORIDE",
      "SIVEXTRO",
      "SKLICE",
      "SKYCLARYS",
      "SKYLA",
      "SKYRIZI",
      "SKYTROFA",
      "SLYND",
      "SMOFLIPID 20%",
      "SOAANZ",
      "SODIUM ACETATE",
      "SODIUM BICARBONATE",
      "SODIUM CHLORIDE 0.45% IN PLASTIC CONTAINER",
      "SODIUM CHLORIDE 0.9%",
      "SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "SODIUM CHLORIDE 0.9% IN STERILE PLASTIC CONTAINER",
      "SODIUM CHLORIDE 14.6%",
      "SODIUM CHLORIDE 23.4%",
      "SODIUM CHLORIDE 3% IN PLASTIC CONTAINER",
      "SODIUM CHLORIDE 5% IN PLASTIC CONTAINER",
      "SODIUM FERRIC GLUCONATE COMPLEX IN SUCROSE",
      "SODIUM FLUORIDE F-18",
      "SODIUM IODIDE I 123",
      "SODIUM IODIDE I 131",
      "SODIUM NITRITE",
      "SODIUM NITROPRUSSIDE",
      "SODIUM OXYBATE",
      "SODIUM PHENYLACETATE AND SODIUM BENZOATE",
      "SODIUM PHENYLBUTYRATE",
      "SODIUM PHOSPHATES",
      "SODIUM PHOSPHATES IN PLASTIC CONTAINER",
      "SODIUM PICOSULFATE, MAGNESIUM OXIDE AND ANHYDROUS CITRIC ACID",
      "SODIUM POLYSTYRENE SULFONATE",
      "SODIUM SULFATE, POTASSIUM SULFATE AND MAGNESIUM SULFATE",
      "SODIUM SULFATE",
      " POTASSIUM SULFATE",
      " MAGNESIUM SULFATE",
      "SODIUM TETRADECYL SULFATE",
      "SODIUM THIOSULFATE",
      "SOGROYA",
      "SOHONOS",
      "SOJOURN",
      "SOLIFENACIN SUCCINATE",
      "SOLIQUA 100/33",
      "SOLIRIS",
      "SOLODYN",
      "SOLOSEC",
      "SOLTAMOX",
      "SOLU-CORTEF",
      "SOLU-MEDROL",
      "SOLUPREP S",
      "SOMA",
      "SOMATULINE DEPOT",
      "SOMAVERT",
      "SONATA",
      "SOOLANTRA",
      "SORAFENIB TOSYLATE",
      "SORBITOL 3% IN PLASTIC CONTAINER",
      "SORBITOL 3.3% IN PLASTIC CONTAINER",
      "SORBITOL-MANNITOL IN PLASTIC CONTAINER",
      "SORILUX",
      "SORINE",
      "SOTALOL HYDROCHLORIDE",
      "SOTRADECOL",
      "SOTYKTU",
      "SOTYLIZE",
      "SOVALDI",
      "SPEVIGO",
      "SPINRAZA",
      "SPIRIVA",
      "SPIRIVA RESPIMAT",
      "SPIRONOLACTONE",
      "SPIRONOLACTONE AND HYDROCHLOROTHIAZIDE",
      "SPORANOX",
      "SPRAVATO",
      "SPRINTEC",
      "SPRITAM",
      "SPRIX",
      "SPRYCEL",
      "SPS",
      "SPY AGENT GREEN KIT",
      "SSD",
      "STALEVO 100",
      "STALEVO 125",
      "STALEVO 150",
      "STALEVO 200",
      "STALEVO 50",
      "STALEVO 75",
      "STAVUDINE",
      "STAVUDINE",
      " LAMIVUDINE",
      "STAVUDINE",
      " LAMIVUDINE W/NEVIRAPINE",
      "STAVUDINE",
      " LAMIVUDINE",
      " EFAVIRENZ",
      "STAVUDINE",
      " LAMIVUDINE",
      " NEVIRAPINE",
      "STEGLATRO",
      "STEGLUJAN",
      "STELARA",
      "STENDRA",
      "STERILE WATER",
      "STERILE WATER FOR INJECTION",
      "STERILE WATER FOR INJECTION IN PLASTIC CONTAINER",
      "STERILE WATER IN PLASTIC CONTAINER",
      "STERITALC",
      "STIE-CORT",
      "STIMUFEND",
      "STIOLTO RESPIMAT",
      "STIVARGA",
      "STRATTERA",
      "STRENSIQ",
      "STREPTOMYCIN SULFATE",
      "STRIBILD",
      "STRIVERDI RESPIMAT",
      "STROMECTOL",
      "STRONTIUM CHLORIDE SR-89",
      "SUBLIMAZE PRESERVATIVE FREE",
      "SUBLOCADE",
      "SUBOXONE",
      "SUCCINYLCHOLINE CHLORIDE",
      "SUCRAID",
      "SUCRALFATE",
      "SUFENTA PRESERVATIVE FREE",
      "SUFENTANIL CITRATE",
      "SUFLAVE",
      "SUGAMMADEX",
      "SUGAMMADEX SODIUM",
      "SULAR",
      "SULFACETAMIDE SODIUM",
      "SULFACETAMIDE SODIUM AND PREDNISOLONE SODIUM PHOSPHATE",
      "SULFADIAZINE",
      "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
      "SULFAMYLON",
      "SULFASALAZINE",
      "SULFATRIM PEDIATRIC",
      "SULINDAC",
      "SUMATRIPTAN",
      "SUMATRIPTAN AND NAPROXEN SODIUM",
      "SUMATRIPTAN SUCCINATE",
      "SUMATRIPTAN",
      " NAPROXEN SODIUM",
      "SUNITINIB MALATE",
      "SUNLENCA",
      "SUNOSI",
      "SUPPRELIN LA",
      "SUPRANE",
      "SUPRAX",
      "SUPREP BOWEL PREP KIT",
      "SURVANTA",
      "SUSTOL",
      "SUSVIMO",
      "SUTAB",
      "SUTENT",
      "SYEDA",
      "SYFOVRE",
      "SYLATRON",
      "SYLVANT",
      "SYMBICORT",
      "SYMBICORT AEROSPHERE",
      "SYMBYAX",
      "SYMDEKO (COPACKAGED)",
      "SYMFI",
      "SYMFI LO",
      "SYMJEPI",
      "SYMLIN",
      "SYMPAZAN",
      "SYMPROIC",
      "SYMTUZA",
      "SYNAGIS",
      "SYNALAR",
      "SYNAREL",
      "SYNDROS",
      "SYNERCID",
      "SYNJARDY",
      "SYNJARDY XR",
      "SYNRIBO",
      "SYNTHROID",
      "SYPRINE",
      "TABRECTA",
      "TACLONEX",
      "TACROLIMUS",
      "TADALAFIL",
      "TADLIQ",
      "TAFINLAR",
      "TAFLUPROST",
      "TAGITOL V",
      "TAGRISSO",
      "TAKHZYRO",
      "TALC",
      "TALICIA",
      "TALTZ",
      "TALZENNA",
      "TAMIFLU",
      "TAMOXIFEN CITRATE",
      "TAMSULOSIN HYDROCHLORIDE",
      "TAPENTADOL",
      "TAPENTADOL HYDROCHLORIDE",
      "TARGRETIN",
      "TARPEYO",
      "TASCENSO ODT",
      "TASIGNA",
      "TASIMELTEON",
      "TASMAR",
      "TAUVID",
      "TAVABOROLE",
      "TAVALISSE",
      "TAVNEOS",
      "TAXOTERE",
      "TAYTULLA",
      "TAZAROTENE",
      "TAZICEF",
      "TAZORAC",
      "TAZTIA XT",
      "TAZVERIK",
      "TECENTRIQ",
      "TECFIDERA",
      "TECHNELITE",
      "TECHNESCAN",
      "TECHNESCAN MAG3",
      "TECHNESCAN PYP KIT",
      "TECHNETIUM TC 99M ALBUMIN AGGREGATED KIT",
      "TECHNETIUM TC 99M MERTIATIDE KIT",
      "TECHNETIUM TC 99M SESTAMIBI",
      "TECHNETIUM TC-99M MEBROFENIN",
      "TECHNETIUM TC-99M MEDRONATE KIT",
      "TECHNETIUM TC99M MERTIATIDE KIT",
      "TEFLARO",
      "TEGRETOL",
      "TEGRETOL-XR",
      "TEGSEDI",
      "TEKTURNA",
      "TELMISARTAN",
      "TELMISARTAN AND AMLODIPINE",
      "TELMISARTAN AND HYDROCHLOROTHIAZIDE",
      "TELMISARTAN",
      " HYDROCHLOROTHIAZIDE",
      "TEMAZEPAM",
      "TEMBEXA",
      "TEMODAR",
      "TEMOZOLOMIDE",
      "TEMSIROLIMUS",
      "TENOFOVIR ALAFENAMIDE",
      "TENOFOVIR ALAFENAMIDE FUMARATE",
      "TENOFOVIR DISOPROXIL FUMARATE",
      "TENORETIC 100",
      "TENORETIC 50",
      "TENORMIN",
      "TEPADINA",
      "TEPEZZA",
      "TEPMETKO",
      "TERAZOSIN HYDROCHLORIDE",
      "TERBINAFINE HYDROCHLORIDE",
      "TERBUTALINE SULFATE",
      "TERCONAZOLE",
      "TERIFLUNOMIDE",
      "TERIL",
      "TERLIVAZ",
      "TESSALON",
      "TESTIM",
      "TESTOPEL",
      "TESTOSTERONE",
      "TESTOSTERONE CYPIONATE",
      "TESTOSTERONE ENANTHATE",
      "TESTOSTERONE UNDECANOATE",
      "TETRABENAZINE",
      "TETRACAINE HYDROCHLORIDE",
      "TETRACYCLINE HYDROCHLORIDE",
      "TEXACORT",
      "TEZSPIRE",
      "THALIDOMIDE",
      "THALITONE",
      "THALLOUS CHLORIDE TL 201",
      "THALOMID",
      "THAM",
      "THEO-24",
      "THEOCHRON",
      "THEOPHYLLINE",
      "THEOPHYLLINE 0.04% AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "THEOPHYLLINE 0.08% AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "THEOPHYLLINE 0.16% AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "THEOPHYLLINE 0.32% AND DEXTROSE 5% IN PLASTIC CONTAINER",
      "THEROXIDIL",
      "THIAMINE HYDROCHLORIDE",
      "THIOGUANINE",
      "THIOLA",
      "THIOLA EC",
      "THIORIDAZINE HYDROCHLORIDE",
      "THIOTEPA",
      "THIOTHIXENE",
      "THYQUIDITY",
      "THYRO-TABS",
      "THYROGEN",
      "TIAGABINE HYDROCHLORIDE",
      "TIAZAC",
      "TIBSOVO",
      "TICAGRELOR",
      "TICLOPIDINE HYDROCHLORIDE",
      "TIGAN",
      "TIGECYCLINE",
      "TIGLUTIK KIT",
      "TIKOSYN",
      "TIMOLOL MALEATE",
      "TIMOPTIC IN OCUDOSE",
      "TIMOPTIC-XE",
      "TINDAMAX",
      "TINIDAZOLE",
      "TIOCONAZOLE",
      "TIOPRONIN",
      "TIOTROPIUM BROMIDE",
      "TIPIRACIL HYDROCHLORIDE AND TRIFLURIDINE",
      "TIROFIBAN HYDROCHLORIDE",
      "TIROSINT",
      "TIROSINT-SOL",
      "TIS-U-SOL",
      "TIS-U-SOL IN PLASTIC CONTAINER",
      "TISSUEBLUE",
      "TIVDAK",
      "TIVICAY",
      "TIVICAY PD",
      "TIZANIDINE HYDROCHLORIDE",
      "TLANDO",
      "TNKASE",
      "TOBI",
      "TOBI PODHALER",
      "TOBRADEX",
      "TOBRADEX ST",
      "TOBRAMYCIN",
      "TOBRAMYCIN AND DEXAMETHASONE",
      "TOBRAMYCIN SULFATE",
      "TOBRAMYCIN SULFATE (PHARMACY BULK)",
      "TOBRAMYCIN SULFATE IN SODIUM CHLORIDE 0.9% IN PLASTIC CONTAINER",
      "TOBREX",
      "Tofacitinib",
      "TOFACITINIB CITRATE",
      "TOFRANIL",
      "TOLAK",
      "TOLCAPONE",
      "TOLMETIN SODIUM",
      "TOLSURA",
      "TOLTERODINE",
      "TOLTERODINE TARTRATE",
      "TOLVAPTAN",
      "TOPAMAX",
      "TOPICORT",
      "TOPIRAMATE",
      "TOPOTECAN HYDROCHLORIDE",
      "TOPROL-XL",
      "TOREMIFENE CITRATE",
      "TORISEL",
      "TORSEMIDE",
      "TOSYMRA",
      "TOUJEO MAX SOLOSTAR",
      "TOUJEO SOLOSTAR",
      "TOVIAZ",
      "TPN ELECTROLYTES IN PLASTIC CONTAINER",
      "TPOXX",
      "TRABECTEDIN",
      "TRACLEER",
      "TRADJENTA",
      "TRALEMENT",
      "TRAMADOL HYDROCHLORIDE",
      "TRAMADOL HYDROCHLORIDE AND ACETAMINOPHEN",
      "TRANDATE",
      "TRANDOLAPRIL",
      "TRANDOLAPRIL AND VERAPAMIL HYDROCHLORIDE",
      "TRANEXAMIC ACID",
      "TRANSDERM SCOP",
      "TRANXENE",
      "TRANYLCYPROMINE SULFATE",
      "TRAVASOL 10% IN PLASTIC CONTAINER",
      "TRAVASOL 5.5% IN PLASTIC CONTAINER",
      "TRAVASOL 8.5% IN PLASTIC CONTAINER",
      "TRAVATAN Z",
      "TRAVOPROST",
      "TRAZIMERA",
      "TRAZODONE HYDROCHLORIDE",
      "TREANDA",
      "TRECATOR",
      "TRELEGY ELLIPTA",
      "TRELSTAR",
      "TREMFYA",
      "TREPROSTINIL",
      "TRESIBA",
      "TRETINOIN",
      "TRETINOIN MICROSPHERE",
      "TREXALL",
      "TREXIMET",
      "TREZIX",
      "TRI LO SPRINTEC",
      "TRI-ESTARYLLA",
      "TRI-LEGEST 21",
      "TRI-LEGEST FE",
      "TRI-LINYAH",
      "TRI-LO-ESTARYLLA",
      "TRI-LO-LINYAH",
      "TRI-LO-MILI",
      "TRI-LUMA",
      "TRI-MILI",
      "TRI-NORINYL 28-DAY",
      "TRI-SPRINTEC",
      "TRIACIN-C",
      "TRIAMCINOLONE ACETONIDE",
      "TRIAMTERENE",
      "TRIAMTERENE AND HYDROCHLOROTHIAZIDE",
      "TRIANEX",
      "TRIAZOLAM",
      "TRIBENZOR",
      "TRICOR",
      "TRIENTINE HYDROCHLORIDE",
      "TRIESENCE",
      "TRIFLUOPERAZINE HYDROCHLORIDE",
      "TRIFLURIDINE",
      "TRIFLURIDINE",
      " TIPIRACIL",
      "TRIGLIDE",
      "TRIHEXYPHENIDYL HYDROCHLORIDE",
      "TRIJARDY XR",
      "TRIKAFTA (COPACKAGED)",
      "TRILEPTAL",
      "TRILIPIX",
      "TRIMETHOBENZAMIDE HYDROCHLORIDE",
      "TRIMETHOPRIM",
      "TRIMETHOPRIM SULFATE AND POLYMYXIN B SULFATE",
      "TRIMIPRAMINE MALEATE",
      "TRINTELLIX",
      "TRIPTODUR KIT",
      "TRISENOX",
      "TRIUMEQ",
      "TRIUMEQ PD",
      "TRIVAGIZOLE 3",
      "TRIVORA-28",
      "TRIZIVIR",
      "TRODELVY",
      "TROGARZO",
      "TROKENDI XR",
      "TROPHAMINE",
      "TROPHAMINE 10%",
      "TROPICACYL",
      "TROPICAMIDE",
      "TROSPIUM CHLORIDE",
      "TRUDHESA",
      "TRULANCE",
      "TRULICITY",
      "TRUVADA",
      "TRUXIMA",
      "TUDORZA PRESSAIR",
      "TUKYSA",
      "TURALIO",
      "TURQOZ",
      "TUXARIN ER",
      "TWIRLA",
      "TWYNEO",
      "TYBLUME",
      "TYBOST",
      "TYDEMY",
      "TYGACIL",
      "TYKERB",
      "TYLENOL",
      "TYMLOS",
      "TYRVAYA",
      "TYSABRI",
      "TYVASO",
      "TYVASO DPI",
      "TYZINE",
      "TZIELD",
      "UBRELVY",
      "UCERIS",
      "UDENYCA",
      "ULORIC",
      "ULSPIRA",
      "ULTANE",
      "ULTIVA",
      "ULTOMIRIS",
      "ULTRA-TECHNEKOW FM",
      "ULTRATAG",
      "ULTRAVATE",
      "ULTRAVIST (PHARMACY BULK)",
      "ULTRAVIST 300",
      "ULTRAVIST 370",
      "UNASYN",
      "UNISOM",
      "UNITHROID",
      "UNITUXIN",
      "UPLIZNA",
      "UPNEEQ",
      "UPTRAVI",
      "UREX",
      "UROCIT-K",
      "UROXATRAL",
      "URSO 250",
      "URSO FORTE",
      "URSODIOL",
      "UVADEX",
      "VABOMERE",
      "VABYSMO",
      "VAGIFEM",
      "VAGISTAT-1",
      "VALACYCLOVIR HYDROCHLORIDE",
      "VALBENAZINE",
      "VALBENAZINE TOSYLATE",
      "VALCHLOR",
      "VALCYTE",
      "VALGANCICLOVIR HYDROCHLORIDE",
      "VALIUM",
      "VALNAC",
      "VALPROATE SODIUM",
      "VALPROIC ACID",
      "VALRUBICIN",
      "VALSARTAN",
      "VALSARTAN AND HYDROCHLOROTHIAZIDE",
      "VALSARTAN",
      " HYDROCHLOROTHIAZIDE",
      "VALSTAR PRESERVATIVE FREE",
      "VALTOCO",
      "VALTREX",
      "VANCOCIN HYDROCHLORIDE",
      "VANCOCIN HYDROCHLORIDE IN PLASTIC CONTAINER",
      "VANCOMYCIN",
      "VANCOMYCIN HYDROCHLORIDE",
      "VANCOMYCIN HYDROCHLORIDE IN PLASTIC CONTAINER",
      "VANDAZOLE",
      "VANFLYTA",
      "VANOS",
      "VAPRISOL",
      "VAPRISOL IN 5% DEXTROSE IN PLASTIC CONTAINER",
      "VARDENAFIL HYDROCHLORIDE",
      "VARENICLINE",
      "VARENICLINE TARTRATE",
      "VARIBAR HONEY",
      "VARIBAR NECTAR",
      "VARIBAR PUDDING",
      "VARIBAR THIN HONEY",
      "VARIBAR THIN LIQUID",
      "VARITHENA",
      "VARUBI",
      "VASCEPA",
      "VASERETIC",
      "VASOPRESSIN",
      "VASOSTRICT",
      "VASOTEC",
      "VAZALORE",
      "VAZCULEP",
      "VECTIBIX",
      "VECTICAL",
      "VECURONIUM BROMIDE",
      "VEGZELMA",
      "VEKLURY",
      "VELCADE",
      "VELETRI",
      "VELIVET",
      "VELPHORO",
      "VELTANE",
      "VELTASSA",
      "VELTIN",
      "VEMLIDY",
      "VENLAFAXINE BESYLATE",
      "VENLAFAXINE HYDROCHLORIDE",
      "VENOFER",
      "VENTAVIS",
      "VENTOLIN HFA",
      "VEOZAH",
      "VERAPAMIL HYDROCHLORIDE",
      "VERARD",
      "VEREGEN",
      "VERELAN",
      "VERELAN PM",
      "VERKAZIA",
      "VERQUVO",
      "VERSACLOZ",
      "VERZENIO",
      "VESICARE",
      "VESICARE LS",
      "VEVYE",
      "VFEND",
      "VIAGRA",
      "VIBATIV",
      "VIBERZI",
      "VIBISONE",
      "VIBRAMYCIN",
      "VIDAZA",
      "VIGABATRIN",
      "VIGADRONE",
      "VIGAMOX",
      "VIIBRYD",
      "VIJOICE",
      "VILAZODONE HYDROCHLORIDE",
      "VILTEPSO",
      "VIMIZIM",
      "VIMPAT",
      "VINBLASTINE SULFATE",
      "VINCRISTINE SULFATE PFS",
      "VINORELBINE TARTRATE",
      "VIOKACE",
      "VIORELE",
      "VIRACEPT",
      "VIRAMUNE XR",
      "VIRAZOLE",
      "VIREAD",
      "VIROPTIC",
      "VISINE",
      "VISINE L.R.",
      "VISIONBLUE",
      "VISIPAQUE 270",
      "VISIPAQUE 320",
      "VISTARIL",
      "VISUDYNE",
      "VITAMIN D",
      "VITAMIN K1",
      "VITRAKVI",
      "VITRASE",
      "VIVELLE",
      "VIVELLE-DOT",
      "VIVIMUSTA",
      "VIVITROL",
      "VIVJOA",
      "VIZAMYL",
      "VIZIMPRO",
      "VOCABRIA",
      "VOGELXO",
      "VOLNEA",
      "VOLTAREN ARTHRITIS PAIN",
      "VONJO",
      "VORAXAZE",
      "VORICONAZOLE",
      "VORTIOXETINE",
      "VORTIOXETINE HYDROBROMIDE",
      "VOSEVI",
      "VOSOL",
      "VOSOL HC",
      "VOTRIENT",
      "VOXZOGO",
      "VPRIV",
      "VRAYLAR",
      "VUITY",
      "VUMERITY",
      "VUSION",
      "VYDUO",
      "VYEPTI",
      "VYLEESI (AUTOINJECTOR)",
      "VYNDAMAX",
      "VYNDAQEL",
      "VYONDYS 53",
      "VYTORIN",
      "VYVANSE",
      "VYVGART",
      "VYXEOS",
      "VYZULTA",
      "WAKIX",
      "WARFARIN SODIUM",
      "WEGOVY",
      "WELCHOL",
      "WELIREG",
      "WELLBUTRIN SR",
      "WELLBUTRIN XL",
      "WERA",
      "WINLEVI",
      "WIXELA INHUB",
      "WOMEN'S ROGAINE",
      "WYNZORA",
      "XACDURO (COPACKAGED)",
      "XACIATO",
      "XADAGO",
      "XALATAN",
      "XALKORI",
      "XANAX",
      "XANAX XR",
      "XARACOLL",
      "XARELTO",
      "XATMEP",
      "XCOPRI",
      "XDEMVY",
      "XELJANZ",
      "XELJANZ XR",
      "XELODA",
      "XELPROS",
      "XELSTRYM",
      "XENAZINE",
      "XENICAL",
      "XENLETA",
      "XENON XE 133",
      "XENOVIEW",
      "XENPOZYME",
      "Xeomin",
      "XERAVA",
      "XERESE",
      "XERMELO",
      "XGEVA",
      "XHANCE",
      "XIAFLEX",
      "XIFAXAN",
      "XIGDUO XR",
      "XIIDRA",
      "XIMINO",
      "XIPERE",
      "XOFIGO",
      "XOFLUZA",
      "XOLAIR",
      "XOPENEX",
      "XOPENEX HFA",
      "XOSPATA",
      "XTAMPZA ER",
      "XTANDI",
      "XULANE",
      "XYLOCAINE",
      "XYLOCAINE W/ EPINEPHRINE",
      "XYOSTED (AUTOINJECTOR)",
      "XYREM",
      "XYROSA",
      "XYWAV",
      "XYZAL ALLERGY 24HR",
      "YAELA",
      "YARGESA",
      "YASMIN",
      "YAZ",
      "YCANTH",
      "YERVOY",
      "YONDELIS",
      "YONSA",
      "YUFLYMA",
      "YUPELRI",
      "YUSIMRY",
      "YUTIQ",
      "ZAFIRLUKAST",
      "ZALEPLON",
      "ZALTRAP",
      "ZANAFLEX",
      "ZANOSAR",
      "ZARONTIN",
      "ZARXIO",
      "ZAVESCA",
      "ZAVZPRET",
      "ZEGALOGUE",
      "ZEGALOGUE (AUTOINJECTOR)",
      "ZEGERID",
      "ZEGERID OTC",
      "ZEJULA",
      "ZELAPAR",
      "ZELBORAF",
      "ZEMBRACE SYMTOUCH",
      "ZEMDRI",
      "ZEMPLAR",
      "ZENATANE",
      "ZENAVOD",
      "ZENPEP",
      "ZEPATIER",
      "ZEPOSIA",
      "ZEPZELCA",
      "ZERBAXA",
      "ZERVIATE",
      "ZESTORETIC",
      "ZESTRIL",
      "ZETIA",
      "ZETONNA",
      "ZEVALIN",
      "ZIAC",
      "ZIAGEN",
      "ZIANA",
      "ZIDOVUDINE",
      "ZIEXTENZO",
      "ZILEUTON",
      "ZILRETTA",
      "ZILXI",
      "ZIMHI",
      "ZINBRYTA",
      "ZINC CHLORIDE",
      "ZINC CHLORIDE IN PLASTIC CONTAINER",
      "ZINC SULFATE",
      "ZINGO",
      "ZINPLAVA",
      "ZIOPTAN",
      "ZIPRASIDONE HYDROCHLORIDE",
      "ZIPRASIDONE MESYLATE",
      "ZIPSOR",
      "ZIRABEV",
      "ZIRGAN",
      "ZITHROMAX",
      "ZOCOR",
      "ZOKINVY",
      "ZOLADEX",
      "ZOLEDRONIC",
      "ZOLEDRONIC ACID",
      "ZOLINZA",
      "ZOLMITRIPTAN",
      "ZOLOFT",
      "ZOLPIDEM TARTRATE",
      "ZOMACTON",
      "ZOMETA",
      "ZOMIG",
      "ZONALON",
      "ZONEGRAN",
      "ZONISADE",
      "ZONISAMIDE",
      "ZONTIVITY",
      "ZORBTIVE",
      "ZORTRESS",
      "ZORYVE",
      "ZOSYN IN PLASTIC CONTAINER",
      "ZOVIA 1/50E-28",
      "ZOVIRAX",
      "ZTALMY",
      "ZTLIDO",
      "ZUBSOLV",
      "ZULRESSO",
      "ZUMANDIMINE",
      "ZURAGARD",
      "ZYCLARA",
      "ZYDELIG",
      "ZYFLO",
      "ZYKADIA",
      "ZYLET",
      "ZYLOPRIM",
      "ZYMAXID",
      "ZYNLONTA",
      "ZYNRELEF KIT",
      "ZYPITAMAG",
      "ZYPREXA",
      "ZYPREXA RELPREVV",
      "ZYPREXA ZYDIS",
      "ZYRTEC ALLERGY",
      "ZYRTEC-D 12 HOUR",
      "ZYTIGA",
      "ZYVOX"
    ]
  }
  
  
export default medications;
  